// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --green: #82bc00;
  --greenDark: #699900;
  --greenSelected: #4E7300;
  --yellow: #FAC239;
  --yellowDark: #faa800;
  --yellowSelected: #D48D00;
  --red: #e40039;
  --redDark: #B0002C;
  --redSelected: #7D001F;
  --blue: #00a1e0;
  --blueDark: #002b59;
}

/* #region Colors */
/* #region Buttons */
.btn-primary {
  background-color: var(--primaryColor);
  border-color: var(--primaryColor);
  color: #fff;
}
.btn-primary:hover {
  background-color: #00162e;
  border-color: #00162e;
}

.btn-warning {
  color: #fff;
  background-color: var(--yellowDark) !important;
  border-color: var(--yellowDark) !important;
}
.btn-warning:hover {
  color: #fff;
  background-color: var(--yellow) !important;
  border-color: var(--yellow) !important;
}

.btn-success {
  color: #fff;
  background-color: var(--green) !important;
  border-color: var(--green) !important;
}
.btn-success:hover {
  color: #fff;
  background-color: var(--greenDark) !important;
  border-color: var(--greenDark) !important;
}

.btn-danger {
  color: #fff;
  background-color: var(--red) !important;
  border-color: var(--red) !important;
}
.btn-danger:hover {
  color: #fff;
  background-color: var(--redDark) !important;
  border-color: var(--redDark) !important;
}

.btn-info {
  color: #fff;
  background-color: var(--blue) !important;
  border-color: var(--blue) !important;
}
.btn-info:hover {
  color: #fff;
  background-color: var(--blueDark) !important;
  border-color: var(--blueDark) !important;
}

.btn-link {
  color: var(--supplementaryColor);
  text-decoration: underline;
  border: none;
  background: none;
  padding: 0px;
  margin: 0px;
}
.btn-link:hover {
  color: var(--secondaryColor);
}

.btn-disabled {
  background: #cecece !important;
  border-color: #cecece !important;
  box-shadow: none;
  color: #737373 !important;
}

.dx-button.dx-state-disabled .dx-button-text,
.dx-button.dx-state-disabled .dx-icon {
  color: rgba(0, 0, 0, 0.87);
}

/* #endregion Buttons */
/* #region Texts */
.text-warning {
  color: var(--yellowDark) !important;
}

.text-success {
  color: var(--green) !important;
}

.text-danger {
  color: var(--red) !important;
}

/* #endregion Texts */
/* #region Backgrounds */
.bg-warning {
  background-color: var(--yellowDark) !important;
  color: #fff;
}

.bg-success {
  background-color: var(--green) !important;
  color: #fff;
}

.bg-danger {
  background-color: var(--red) !important;
  color: #fff;
}

.bg-info {
  background-color: var(--blue) !important;
}

/* #endregion Backgrounds */
.dx-texteditor.dx-editor-filled.dx-state-disabled, .dx-texteditor.dx-editor-filled.dx-state-readonly, .dx-texteditor.dx-editor-filled.dx-state-readonly.dx-state-hover {
  background-color: rgb(245, 245, 245);
}

.dx-state-disabled .dx-widget,
.dx-state-disabled.dx-widget {
  opacity: 0.5;
}

/* #endregion Colors */
/* #region Basis */
a {
  color: var(--supplementaryColor);
}
a:hover {
  color: var(--secondaryColor);
}

.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 1rem 1.5rem;
  overflow: auto;
}

.content-row {
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 0.5rem;
}

.content-cell {
  padding: 0.25rem;
}

.dx-item.dx-radiobutton {
  margin: 0 0 1px;
}

.label,
.dx-label span {
  font-weight: bold;
}

.label-disabled {
  color: #b6b6b6 !important;
}

.highlight {
  background-color: var(--yellow);
}

.content-cell-tiles {
  flex: 80;
}

.content-cell-tiles-expand {
  padding-right: 16px;
}

[hidden] {
  display: none;
}

.dx-scrollable {
  width: 100%;
}

.btn {
  text-transform: uppercase;
  border-radius: 4px;
}

.row > * {
  width: auto;
}

.separator {
  border-top: 1px solid var(--primaryColor);
  margin: 0.25rem 0 0.75rem;
}

/* #endregion Basis */
/* #region Nezarazene */
.custom-icon svg {
  height: 20px;
  width: 16px;
  margin-top: -5px;
}

.toggler-down::after {
  content: "";
  display: inline-block;
  margin: 2px 0;
  width: 6px;
  height: 6px;
  border-top: 1px solid black;
  border-right: 1px solid black;
  -moz-transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
}

.toggler-up::after {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  border-top: 1px solid black;
  border-right: 1px solid black;
  -moz-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.dx-fileuploader-container .dx-fileuploader-cancel-button {
  border-color: transparent;
}
.dx-fileuploader-container .dx-fileuploader-cancel-button .dx-icon.dx-icon-close {
  color: var(--requiredMarkColor);
}

.dx-fileuploader-wrapper {
  padding: 0;
}

.form-item {
  padding: 0.25rem 1.5rem 0.5rem 0;
}

.dx-radiobutton-icon::after {
  content: none;
}

.ellipsis-3-rows {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dx-collection > hr {
  margin: 5px 0 5px 0;
}

.mainRibbonContainer #mainRibbon-container .dx-multiview-wrapper .mainRibbonGroupContainer .mainRibbonGroup .mainRibbonSubGroupContainer .mainRibbonSubGroup #ribBtnfnClearFilter {
  margin-top: 18px;
}

#login .buttonGroup .dx-box-item {
  flex: unset !important;
}

.u-no-max-size {
  max-height: none !important;
  max-width: none !important;
}

/* #endregion Nezarazene */
/* #region MainRibbon */
.mainRibbonContainer .dx-label span {
  font-weight: normal;
}
.mainRibbonContainer .menu-subcell-date-only {
  list-style: none;
  margin-left: 8px;
  margin-right: 8px;
}
.mainRibbonContainer #rangePickerInput {
  height: 26px;
  width: 170px;
  background-color: rgba(0, 0, 0, 0.04);
  border: none;
  border-bottom: 1px solid var(--primaryColor);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
}
.mainRibbonContainer .menu-subcell-date {
  list-style: none;
  align-self: end;
}
.mainRibbonContainer .menu-subcell-orderBy {
  list-style: none;
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 15px;
}
.mainRibbonContainer .menu-subcell-orderBy-sort {
  list-style: none;
  margin-top: 17px;
  margin-right: 8px;
}
.mainRibbonContainer .menu-subcell-id {
  margin-left: 8px;
  margin-right: 8px;
  list-style: none;
  margin-right: 15px;
}
.mainRibbonContainer .menu-subcell-search {
  margin-left: 8px;
  margin-right: 8px;
  list-style: none;
}
.mainRibbonContainer .menu-subcell-add {
  margin-left: 8px;
  margin-right: 8px;
}
.mainRibbonContainer .menu-subcell-countdown {
  margin-left: 8px;
  margin-right: 8px;
  list-style: none;
  white-space: pre-wrap;
  text-align: center;
  min-width: 150px;
}
.mainRibbonContainer .menu-subcell-clearbtn {
  list-style: none;
  margin-left: 8px;
  margin-right: 8px;
}
.mainRibbonContainer #btnDayUp, .mainRibbonContainer #btnDayDown {
  margin: 2px;
}
.mainRibbonContainer #btnDayUp.dx-button-has-icon, .mainRibbonContainer #btnDayDown.dx-button-has-icon {
  min-width: 25px;
}
.mainRibbonContainer #btnDayUp .dx-button-content, .mainRibbonContainer #btnDayDown .dx-button-content {
  padding-block: 5px;
  -webkit-padding-start: 5px;
  padding-inline-start: 5px;
  -webkit-padding-end: 5px;
  padding-inline-end: 5px;
}
.mainRibbonContainer .menu-subcell {
  list-style: none;
}

/* #endregion MainRibbon */
/* #region HomeTile */
.tilesContainer #Tile_2_1_ContentsWrapper {
  max-height: 400px;
}
.tilesContainer #Tile_2_2_ContentsWrapper {
  max-height: 400px;
}

/* #endregion HomeTile */
/* #region DataGrid */
.dx-datagrid .dx-row > td,
.dx-datagrid .dx-datagrid-table .dx-header-row > td {
  padding: 5px 11px;
}
.dx-datagrid .dx-row:not(.dx-master-detail-row) > td .btn-sm {
  padding: 2px 5px;
  font-size: 11px;
}
.dx-datagrid .dx-row-lines > td {
  border-bottom: 1px solid #eee;
}

.dx-datagrid-content .dx-datagrid-table .dx-row:not(.dx-master-detail-row) > td:last-child,
.dx-datagrid-content .dx-datagrid-table .dx-row:not(.dx-master-detail-row) > td:nth-child(7),
.dx-datagrid-content .dx-datagrid-table .dx-row:not(.dx-master-detail-row) > td:nth-child(8) {
  padding: 2px 11px;
}

.dx-datagrid-content .dx-datagrid-table .dx-row td {
  height: 31px;
}

.btn-same-width {
  width: 60px;
}

.btn-same-width-lg {
  width: 125px;
}

#dataGridMasterDetailContainer {
  height: 100%;
}

#editGridpartial {
  width: 100%;
}
#editGridpartial .dx-toolbar-after {
  width: 100% !important;
  padding: 0 !important;
}
#editGridpartial .dx-datagrid-search-panel {
  width: 100% !important;
  margin: 0 !important;
}

#gridZjisteni .dx-toolbar-after {
  width: 100% !important;
  padding: 0 !important;
}
#gridZjisteni .dx-datagrid-search-panel {
  width: 100% !important;
  margin: 0 !important;
}

#orgStrTreeList .dx-treelist-header-panel {
  width: 100%;
  padding: 0;
}
#orgStrTreeList .dx-treelist-header-panel .dx-toolbar-after {
  padding: 0;
  width: 100%;
}
#orgStrTreeList .dx-treelist-header-panel .dx-treelist-search-panel {
  width: 100% !important;
  margin: 0 !important;
}

/* #endregion DataGrid */
/* #region Toast */
.dx-toast-content {
  right: 0.5rem;
  left: auto !important;
  bottom: 0.75rem;
  top: auto !important;
  transform: none !important;
}

/* #endregion Toast */
/* #region Detail */
.dx-master-detail-cell {
  background-color: rgba(0, 0, 0, 0.1019607843) !important;
}
.dx-master-detail-cell .detail {
  padding: 0;
}

.detail {
  min-height: 280px;
  min-width: 400px;
  padding: 0.5rem 0.75rem;
  display: flex;
  flex-direction: column;
}

/* #region Radek s tlacitky */
.detail > .title {
  margin-bottom: 8px;
  flex-grow: 0;
  display: flex;
  align-items: center;
}

.title-bar {
  margin-left: auto;
}
.title-bar > .title {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding-right: 40px;
}
.title-bar > .actions {
  margin-left: auto;
  display: flex;
  -webkit-flex-wrap: wrap;
  gap: 10px;
}
.title-bar > .actions .dx-button .dx-button-content {
  padding: 6px 12px;
}
.title-bar > .actions .btn {
  padding: 3px 12px;
  font-size: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
}

/* #endregion Radek s tlacitky */
.detail-content-row {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.detail-content-row > .content-cell {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}

.detail-text-content {
  text-wrap: pretty;
}
.detail-text-content div {
  white-space: normal;
  padding: 0 4px;
  border-radius: 4px;
}

.detail-row {
  display: flex;
  position: relative;
  gap: 100px;
  padding-top: 0.25rem;
}
.detail-row > .cell {
  min-width: 160px;
  display: flex;
  width: 30%;
  align-items: center;
  border-bottom: 1px solid #EFF2F5;
  margin-bottom: 10px;
}
.detail-row > .cell .label {
  padding-left: 0.25rem;
  margin-right: 10px;
}
.detail-row .title-part {
  margin: 1.5rem 0.25rem 0.5rem;
  font-weight: bold;
  font-size: 1.1em;
}
.detail-row > .empty-cell {
  min-width: 160px;
  display: flex;
  width: 30%;
  align-items: center;
  margin-bottom: 10px;
}
.detail-row > .only-one-cell {
  min-width: 160px;
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #EFF2F5;
  margin-bottom: 10px;
}
.detail-row > .only-one-cell .label {
  padding-left: 0.25rem;
  margin-right: 10px;
}

.detail-row-buttons {
  display: flex;
  padding-top: 0.5rem;
  position: fixed;
  bottom: 0;
  padding-bottom: 15px;
  width: 96%;
  background-color: white;
}
.detail-row-buttons .button {
  margin-right: 1rem;
}

.detail-row-buttons-gap {
  padding-top: 40px;
}

.cell-description {
  display: inline-table;
  width: 75%;
}
.cell-description > .popis {
  color: var(--redDark);
}
.cell-description > .vlivy {
  color: var(--red);
}

.detail-duplicity-row {
  display: flex;
  flex-direction: row;
  padding-bottom: 30px;
  gap: 30px;
}

.duplicity-cell {
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 10px;
}

.detail-duplicity-cell {
  font-weight: bold;
}

.pagination-bar {
  display: flex;
  flex-direction: row;
  position: relative;
  gap: 100px;
}

.history-record-loader-show,
.history-record-loader-hide,
.duplicity-record-loader-show,
.duplicity-record-loader-hide {
  padding-top: 0.25rem;
}

.history-record-loader-show .dx-button,
.history-record-loader-hide .dx-button,
.duplicity-record-loader-show .dx-button,
.duplicity-record-loader-hide .dx-button {
  height: auto;
}

.history-record-loader-show .dx-button-content,
.history-record-loader-hide .dx-button-content,
.duplicity-record-loader-show .dx-button-content,
.duplicity-record-loader-hide .dx-button-content {
  font-size: 0.9em;
}

.history {
  padding-left: 8px;
  padding-top: 20px;
  width: 45%;
}
.history button {
  border: none;
  background-color: #eaeaea;
}

.history-record {
  font-size: 11px;
}
.history-record button {
  background-color: transparent;
  border: none;
  padding: 2px 6px;
  border-radius: 4px;
}

.history-record-hidden {
  display: none;
}

.answer-record {
  font-size: 11px;
}
.answer-record button {
  background-color: transparent;
  border: none;
  padding: 2px 6px;
  border-radius: 4px;
}

.duplicity {
  padding-left: 8px;
  padding-top: 20px;
  position: inherit;
  width: 45%;
}
.duplicity button {
  border: none;
  background-color: transparent;
}

.duplicity-record {
  font-size: 11px;
}

.duplicity-record-hidden {
  display: none;
}

.detail-toggle-button {
  font-size: 11px;
  padding: 2px 5px;
}
.detail-toggle-button span {
  margin-left: 3px;
}

/* #endregion Detail */
/* #region PopUp */
.newRecord div {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.time-row {
  background-color: #efefef;
  padding: 0px 5px 15px;
}

.cell-invoices {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.new-popup-cell-input-required .dx-texteditor::before {
  border-bottom: 2px solid var(--secondaryColor);
  transform: scale(1);
}
.new-popup-cell-input-required .dx-label span::after {
  content: " *";
  color: var(--secondaryColor);
}

.new-popup-cell-file-required .dx-fileuploader-button {
  border: 2px solid var(--secondaryColor);
}
.new-popup-cell-file-required .dx-fileuploader-button span::after {
  content: " *";
  color: var(--secondaryColor);
}

.new-popup-cell:has(div.dx-button) {
  align-self: end;
}

.new-popup-cell:has(div div.dx-checkbox) {
  align-self: center;
}

.new-popup-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 5px 15px;
}

.new-popup-cell-label {
  font-weight: bold;
}

.history-popup-container {
  display: grid;
}

.history-popup-row {
  display: flex;
}

.history-popup-cell {
  padding: 0 0.25rem;
}

.history-popup-cell-input {
  padding: 0 0.25rem;
}

.history-popup-cell-input-diff {
  color: var(--red);
}

.history-popup-main-content {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr;
  width: 100%;
}

.history-popup-main-content-same-column {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
}

ins {
  background-color: var(--green);
}

del {
  background-color: #ffefc7;
}

.dx-popup-content:has(.detail) .detail {
  padding: 0;
}

/* #endregion PopUp */
.popup-map-div {
  min-height: calc(100vh - 400px);
}
.popup-map-div #mapDiv {
  border: 1px solid #ccc;
}

/* #region Publikační úlohy */
#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-toolbar.dx-filemanager-general-toolbar {
  left: 0;
  min-width: 0;
}
#fileManagerPublishingTasksContainer.search-mode .dx-toolbar-items-container {
  display: flex;
  align-items: center;
}
#fileManagerPublishingTasksContainer.search-mode .dx-toolbar-before {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}
#fileManagerPublishingTasksContainer.search-mode .dx-toolbar-after {
  flex: 0 0 auto;
  margin-left: 8px;
}
#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}
#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs .dx-menu-item-wrapper,
#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs .dx-breadcrumbs-item,
#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs .dx-breadcrumbs-separator {
  display: none !important;
}
#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs .custom-search-caption {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 32px;
  position: relative;
  top: -16px;
}
#fileManagerPublishingTasksContainer .dx-filemanager-dirs-tree .dx-treeview-item-content i.dx-icon {
  align-self: center;
}
#fileManagerPublishingTasksContainer .dx-filemanager-dirs-tree .dx-treeview-item-content span.dx-filemanager-dirs-tree-item-text {
  white-space: normal;
}
#fileManagerPublishingTasksContainer .dx-filemanager-toolbar.dx-filemanager-general-toolbar {
  position: absolute;
  right: 0;
  background-color: transparent;
  min-width: 100px;
  z-index: 1;
}
#fileManagerPublishingTasksContainer .dx-filemanager-toolbar.dx-filemanager-general-toolbar > .dx-toolbar {
  width: 100%;
  background-color: transparent;
}
#fileManagerPublishingTasksContainer .dx-filemanager-dirs-panel {
  border-right: 1px solid #ccc;
}
#fileManagerPublishingTasksContainer .dx-datagrid-table .dx-row {
  border-bottom: 1px solid #eee;
}
#fileManagerPublishingTasksContainer .dx-datagrid-table .dx-row:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.04);
}

.viewport:has(#fileManagerPublishingTasksContainer) .overlay-view {
  border-left: none !important;
  border-top: 1px solid #ccc;
}

/* #endregion Publikační úlohy */
/* #region Popis site */
/* #region Mapa */
.mapa-search-display-mode {
  display: flex;
  gap: 18px;
  margin-top: 8px;
  align-items: center;
}

.mapa-search-display-mode-item {
  display: flex;
  gap: 5px;
  align-items: center;
  margin: 0;
  cursor: pointer;
}

#mapaTrackContextMenu {
  position: fixed;
  display: none;
  min-width: 190px;
  padding: 4px;
  background: #fff;
  border: 1px solid #c8c8c8;
  border-radius: 3px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.22);
  z-index: 14000;
}
#mapaTrackContextMenu button {
  width: 100%;
  padding: 7px 10px;
  border: 0;
  background: transparent;
  text-align: left;
  white-space: nowrap;
}
#mapaTrackContextMenu button:hover, #mapaTrackContextMenu button:focus {
  background: #f0f0f0;
  outline: none;
}

/* #endregion Mapa*/
/* #region Trate */
.track-region {
  margin-bottom: 24px;
}

.region-header {
  margin: 0.75px 0 0.5rem;
  padding: 0 0.5rem;
  color: var(--secondaryColor);
  border-bottom: 3px solid var(--secondaryColor);
  display: flex;
  justify-content: space-between;
}
.region-header-text {
  font-weight: 700;
}
.region-header-buttons {
  display: flex;
  height: 28px;
  padding-right: 16px;
  gap: 8px;
}

.track-container {
  width: 100%;
  max-width: 1200px;
  margin: 1.5rem auto 1rem;
  font-family: Arial, sans-serif;
}

.track-stats {
  width: 100%;
  padding: 0.25rem 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
}
.track-stats.okay {
  background-color: color-mix(in srgb, var(--green), white 50%);
  color: var(--greenSelected);
  border-color: var(--greenSelected);
}
.track-stats.not-okay {
  background-color: color-mix(in srgb, var(--red), white 50%);
  color: var(--redSelected);
  border-color: var(--redSelected);
}
.track-stats .stat-icon {
  border: 0.5px solid;
  border-radius: 50%;
  width: 1.7rem;
  height: 1.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
}
.track-stats .stat-icon i {
  font-size: 1.2rem;
}
.track-stats .stat-info {
  overflow-y: auto;
  height: 2.2rem;
  align-content: center;
}

.track-group {
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 0.5rem 0.75rem;
}

.track-header {
  background-color: var(--primaryColor);
  padding: 0.5rem 1rem;
  border-bottom: 2px solid var(--primaryColor);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.track-header-text {
  color: white;
  font-weight: bold;
  margin: 0;
}
.track-header-buttons {
  display: flex;
  gap: 8px;
}

.track-item {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  transition: background-color 0.15s ease;
}
.track-item:last-child {
  border-bottom: none;
}
.track-item:hover, .track-item:focus-within {
  background-color: rgba(0, 0, 0, 0.2);
}
.track-item:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.04);
}
.track-item:nth-of-type(odd):hover {
  background-color: rgba(0, 0, 0, 0.2);
}

.track-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.track-number {
  font-weight: bold;
  color: var(--primaryColor);
  margin-right: 15px;
  min-width: 60px;
  font-size: 14px;
}

.track-name {
  color: #333;
  font-size: 14px;
}

.track-buttons {
  display: flex;
  gap: 8px;
}

.btn-track {
  padding: 3px 13px;
  border: 2px solid transparent;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.btn-track:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.btn-track-detail {
  background-color: var(--supplementaryColor);
  color: white;
}
.btn-track-detail:hover, .btn-track-detail:focus {
  background-color: color-mix(in srgb, var(--supplementaryColor), black 17%);
}
.btn-track-detail:active {
  background-color: color-mix(in srgb, var(--supplementaryColor), black 30%);
}

.btn-track-pdf {
  background-color: var(--secondaryColor);
  color: white;
}
.btn-track-pdf:hover, .btn-track-pdf:focus {
  background-color: color-mix(in srgb, var(--secondaryColor), black 17%);
}
.btn-track-pdf:active {
  background-color: color-mix(in srgb, var(--secondaryColor), black 30%);
}

.btn-track-pdf-zip {
  background-color: var(--green);
  color: white;
}
.btn-track-pdf-zip:hover, .btn-track-pdf-zip:focus {
  background-color: color-mix(in srgb, var(--green), black 17%);
}
.btn-track-pdf-zip:active {
  background-color: color-mix(in srgb, var(--green), black 30%);
}

.btn-track-xml-zip {
  background-color: #6472b6;
  color: white;
}
.btn-track-xml-zip:hover, .btn-track-xml-zip:focus {
  background-color: color-mix(in srgb, #6472b6, black 17%);
}
.btn-track-xml-zip:active {
  background-color: color-mix(in srgb, #6472b6, black 30%);
}

.btn-track-xml {
  background-color: var(--primaryColor);
  color: white;
}
.btn-track-xml:hover, .btn-track-xml:focus {
  background-color: color-mix(in srgb, var(--primaryColor), black 30%);
}
.btn-track-xml:active {
  background-color: color-mix(in srgb, var(--primaryColor), black 50%);
}

.btn-track-pdf-outline {
  background-color: transparent;
  color: var(--secondaryColor);
  border: 2px solid var(--secondaryColor);
}
.btn-track-pdf-outline:hover {
  background-color: var(--secondaryColor);
  color: white;
}

.btn-track-pdf-zip-outline {
  background-color: transparent;
  color: var(--green);
  border: 2px solid var(--green);
}
.btn-track-pdf-zip-outline:hover {
  background-color: var(--green);
  color: white;
}

.btn-track-xml-outline {
  background-color: transparent;
  color: var(--primaryColor);
  border: 2px solid var(--primaryColor);
}
.btn-track-xml-outline:hover {
  background-color: var(--primaryColor);
  color: white;
}

.track-header-buttons .btn-track:disabled {
  opacity: 0.5;
}

.popup-map-div #mapDiv {
  border: 1px solid #ccc;
}

/* #endregion Trate */
/* #region Dokumenty */
.viewport:has(#fileManagerPublishingTasksContainer) {
  position: relative;
  height: 100%;
  overflow: hidden;
  isolation: isolate;
}
.viewport:has(#fileManagerPublishingTasksContainer) #view-content-preview {
  z-index: 1000;
}
.viewport:has(#fileManagerPublishingTasksContainer) #fileManagerPublishingTasksContainer {
  position: relative;
  height: 100%;
  width: 100%;
}
.viewport:has(#fileManagerPublishingTasksContainer) #view-content-preview-h1 {
  color: var(--secondaryColor);
  font-weight: bold;
  margin: 0;
  align-self: center;
}
.viewport:has(#fileManagerPublishingTasksContainer) .view-content-overlay {
  display: none;
  flex-direction: column;
  height: calc(100% - 40px);
}
.viewport:has(#fileManagerPublishingTasksContainer) .overlay-view {
  position: absolute;
  top: 40px;
  right: 0;
  bottom: 0;
  left: 300px;
  background: white;
  z-index: 1000;
  overflow: hidden;
  display: none;
  border-left: 1px solid #ccc;
}

#fileManagerPublishingTasksContainer {
  border: none;
}

/* #endregion Dokumenty */
/* #region Mapa */
#mappartial {
  width: 100%;
  height: calc(100vh - 56px);
}
#mappartial #mapMapa {
  position: relative;
  width: 100%;
  height: 100%;
}
#mappartial #mapMapa .top-left-corner {
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 5000;
}
#mappartial #mapMapa .top-left-corner #dateFilter,
#mappartial #mapMapa .top-left-corner #oblastFilter,
#mappartial #mapMapa .top-left-corner #tools {
  display: flex;
  margin-bottom: 0.5rem;
  padding-left: 0.75rem;
}
#mappartial #mapMapa .top-left-corner .icon-bg {
  background-color: white;
  border-radius: 7px;
  width: 33px;
  height: 33px;
  padding: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
#mappartial #mapMapa .top-left-corner .icon-bg .icon {
  width: 27px;
  height: 27px;
  cursor: pointer;
}
#mappartial #mapMapa .top-left-corner .map-pop-up {
  padding: 0.75rem 1rem;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  width: fit-content;
  margin-inline-start: 0.5rem;
}
#mappartial #mapMapa .top-left-corner #oblastFilter .map-pop-up {
  width: 225px;
  padding: 0.75rem;
}
#mappartial #mapMapa .top-left-corner #oblastFilter .map-pop-up .oblast-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
#mappartial #mapMapa .top-left-corner #oblastFilter .map-pop-up .dx-datagrid-search-panel {
  width: 100%;
  margin: 0;
  padding: 0.5rem 0;
}
#mappartial #mapMapa .top-left-corner #dateFilter .map-pop-up .casovy-filter-label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
#mappartial #mapMapa .top-left-corner #tools .map-pop-up {
  width: 170px;
  text-align: center;
  padding: 0.75rem;
}
#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button {
  width: 50%;
  padding: 0.25rem;
}
#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button .tools-icon {
  width: 27px;
  height: 27px;
}
#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button #mapTileLayerIcon {
  fill: none;
  stroke: black;
}
#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button:hover {
  cursor: pointer;
}
#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button:hover .tools-icon {
  fill: var(--secondaryColor);
}
#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button:hover #mapTileLayerIcon {
  fill: none;
  stroke: #ff8c00;
}
#mappartial #mapDiv {
  width: 100%;
  height: 100%;
}

/* #endregion Mapa */
/* #endregion Popis site */
/* #region Kontrolni Cinnost */
.tagbox-scrollable .dx-texteditor-input-container {
  max-height: 100px;
  overflow-y: auto;
}

.zamestnanec-dropdown .dx-list-item {
  font-size: 10px;
  line-height: 14px;
}

.new-popup-content .dx-tabpanel .dx-multiview-item-content {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 500px;
}

/* #endregion Kontrolni Cinnost */
/* #region Kalendar */
.calendar-event-detail {
  padding: 2px 8px;
}
.calendar-event-detail:hover {
  background-color: var(--primaryColor);
  color: white;
}

.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-popup-content .dx-list-item .dx-list-item-content:has(.calendar-event-detail) {
  padding: 0;
}

/* #endregion Kalendar */
/* #region Smernice */
#bodyContainer {
  display: flex;
  height: 100%;
}
#bodyContainer .menu {
  width: 220px;
  padding: 1rem 0;
  border-right: 1px solid #ccc;
  overflow: auto;
}
#bodyContainer .menu a {
  display: block;
  text-decoration: none;
  color: var(--primaryColor);
  font-size: 14px;
  padding: 0.5rem 1.25rem;
}
#bodyContainer .menu a:hover {
  background-color: var(--primaryColor);
  color: white;
}
#bodyContainer .menu button {
  padding: 0.5rem 0.75rem;
  margin: 0.5rem 0.75rem;
  border: none;
  background-color: var(--primaryColor);
  color: white;
  font-size: 14px;
  border-radius: 4px;
  text-transform: uppercase;
}
#bodyContainer .menu button:hover {
  background-color: var(--supplementaryColor);
}
#bodyContainer .content {
  padding: 1rem 1.25rem;
  overflow: auto;
}

/* #endregion Smernice */
/* #endregion Kontrolni Cinnost*/
/* #region Sprava obsahu */
#fileManager {
  height: 100%;
}
#fileManager .dx-filemanager .dx-filemanager-breadcrumbs {
  border-bottom: none;
}
#fileManager .dx-filemanager-details.dx-filemanager-files-view {
  padding-right: 0.5rem;
}

.new-popup-cell-input.popup-button {
  padding: 10px 0;
}

.dx-popup-content:has(.popup-footer) {
  padding-bottom: 100px;
}

.popup-footer {
  background-color: white;
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  justify-content: start;
  padding: 0.75rem 2rem 1rem 0;
}

/* #endregion Sprava obsahu */
/* #region Administrace */
/* #region Správa skupin */
#usersGrid .dx-toolbar-after {
  width: 100% !important;
  padding: 0 !important;
}
#usersGrid .dx-toolbar-after .dx-datagrid-search-panel {
  width: 100% !important;
  margin: 0 !important;
}

/* #endregion Správa skupin */
/* #region Administrace */
/* Start Úprava TitleBaru */
#titleBar {
  display: flex;
  align-items: center;
}
#titleBar > .titleBar-name {
  flex: 0 1 auto;
  width: auto;
  justify-content: flex-start;
  margin-right: auto;
  padding-left: 0;
}
#titleBar #btnSearch,
#titleBar #btnHelp {
  cursor: pointer;
  font-size: 18px;
}
#titleBar #btnSearch:hover,
#titleBar #btnHelp:hover {
  color: var(--secondaryColor);
}

/* Konec Úprava TitleBaru */
/* Start Ribbon horizontal menu */
.main-ribbon-container {
  border-bottom: solid 1px var(--secondaryColor);
  /* Moduly */
  /* Tasky / Submoduly */
  /* Hlavní obsah pro funkce a filtry */
  /* Společné */
  /* Funkce / filtry */
  /* Legacy funkce / filtry */
}
.main-ribbon-container .rh-menu {
  padding-top: 0.25rem;
  background: var(--primaryColor);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.main-ribbon-container .rh-menu .rh-menu-item {
  color: #fff;
  cursor: pointer;
  padding: 4px 8px 4px 8px;
  white-space: nowrap;
  border-top: 1px solid transparent;
  border-top-left-radius: 5px 5px;
  border-top-right-radius: 5px 5px;
}
.main-ribbon-container .rh-menu .rh-menu-item:hover {
  background: var(--secondaryColor);
}
.main-ribbon-container .rh-menu .rh-menu-item.selected {
  background: var(--activeModulColor);
  font-weight: bold;
}
.main-ribbon-container .rh-menu .rh-menu-item.active {
  background: #bfc7da;
  color: var(--primaryColor);
}
.main-ribbon-container .rh-submenu {
  height: 36px;
  color: var(--primaryColor);
  background: #bfc7da;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow: hidden;
  /* Scrollovací část panelu */
  /* Tlačítko pro skrytí/zobrazení funkcí */
}
.main-ribbon-container .rh-submenu .rh-submenu-scroll {
  height: 100%;
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-left: 2px;
  overflow-x: auto;
  overflow-y: hidden;
}
.main-ribbon-container .rh-submenu .rh-submenu-scroll::-webkit-scrollbar {
  height: 3px;
}
.main-ribbon-container .rh-submenu .rh-submenu-scroll::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 0.04);
}
.main-ribbon-container .rh-submenu .rh-submenu-scroll::-webkit-scrollbar-thumb {
  background-color: var(--primaryColor);
}
.main-ribbon-container .rh-submenu .rh-submenu-scroll .rh-submenu-item {
  cursor: pointer;
  padding: 4px 8px;
  margin: 5px 2px;
  white-space: nowrap;
  background: rgb(223.3168316832, 227.2772277228, 236.6831683168);
  border: 1px solid transparent;
  border-radius: 3px;
}
.main-ribbon-container .rh-submenu .rh-submenu-scroll .rh-submenu-item:hover {
  background: var(--secondaryColor);
  color: #fff;
}
.main-ribbon-container .rh-submenu .rh-submenu-scroll .rh-submenu-item.selected {
  background: var(--activeModulColor);
  color: #fff;
  font-weight: bold;
}
.main-ribbon-container .rh-submenu .rh-submenu-scroll .rh-submenu-item-separator {
  width: 1px;
  height: 20px;
  margin: 0;
  padding: 0;
  border-right: solid 1px var(--companyGray);
  flex: 0 0 1px;
}
.main-ribbon-container .rh-submenu .rh-toggle-button {
  height: 100%;
  width: 32px;
  min-width: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primaryColor);
  background: #bfc7da;
  cursor: pointer;
  z-index: 2;
}
.main-ribbon-container .main-ribbon-content {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-wrap: nowrap;
  line-height: normal;
}
.main-ribbon-container .main-ribbon-content::-webkit-scrollbar {
  height: 3px;
}
.main-ribbon-container .main-ribbon-content::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 0.04);
}
.main-ribbon-container .main-ribbon-content::-webkit-scrollbar-thumb {
  background-color: var(--secondaryColor);
}
.main-ribbon-container .rh-function,
.main-ribbon-container .rh-function-legacy {
  padding: 0 0.25rem 0 0;
  margin: 0;
  display: flex;
  flex-wrap: nowrap;
  width: max-content;
  flex: 0 0 auto;
  list-style: none;
}
.main-ribbon-container .rh-function {
  /* Oddělovač skupin */
}
.main-ribbon-container .rh-function .rh-function-group {
  list-style: none;
  padding: 0 2px;
  display: flex;
  flex-direction: column;
  height: 80px;
  flex: 0 0 auto;
  /* SKupina položek */
  /* Popis skupiny položek */
}
.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items {
  height: 80px;
  min-height: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  /* Jednotlivé položky */
}
.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items .rh-function-item {
  width: min-content;
  min-width: 50px;
  max-width: 80px;
  max-height: 76px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 10.7px;
  border: none;
  background: none;
}
.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items .rh-function-item .icon {
  height: 25px;
  width: 25px;
  margin: 0 auto;
  flex: 0 0 25px;
  /* Bootstrap Icons glyf (<i class="bi ...">) použitý namísto <img> -
     bez explicitního font-size zůstává v defaultní (malé) velikosti
     textu, protože width/height na fontové ikoně nic nedělá. Zarovnání
     uvnitř 25px boxu stejně jako u obrázkových ikon ribbonu. */
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items .rh-function-item .icon .bi {
  font-size: 25px;
  line-height: 1;
}
.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items .rh-function-item .text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  width: min-content;
  max-width: 100%;
  overflow: hidden;
  overflow-wrap: normal;
  text-overflow: ellipsis;
}
.main-ribbon-container .rh-function .rh-function-group .rh-functions-caption {
  height: 0px;
  min-height: 0px;
  text-align: center;
  color: var(--companyGray);
  border-top: 1px solid rgba(0, 0, 0, 0.0392156863);
  padding: 2px 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8em;
}
.main-ribbon-container .rh-function .rh-function-group-separator {
  list-style: none;
  border-right: solid 1px var(--companyGray);
  width: 1px;
  min-width: 1px;
  height: 80px;
  flex: 0 0 1px;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroup {
  list-style: none;
  padding: 0;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer {
  height: 80px;
  min-height: 80px;
  display: inline-flex;
  align-items: center;
  padding: 0;
  width: min-content;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer li {
  margin-left: 8px;
  margin-right: 8px;
  list-style: none;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer .mainRibbonBtn {
  font-size: 10.7px;
  border: none;
  background: none;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer .mainRibbonBtn .mainRibbonBtnImg {
  height: 25px;
  width: 25px;
  margin: 0 auto;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer .mainRibbonBtn .mainRibbonBtnCaption {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  width: 100%;
  padding: 3px 2px 0;
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer .btn-track {
  padding: 3px 13px;
  border: 2px solid transparent;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubModule {
  text-align: center;
  color: var(--companyGray);
  border-top: 1px solid rgba(0, 0, 0, 0.0392156863);
  padding: 2px 5px;
  overflow: hidden;
  white-space: nowrap;
  font-size: 0.8em;
}
.main-ribbon-container .rh-function-legacy .mainRibbonGroupSep {
  list-style: none;
  border-right: solid 1px var(--companyGray);
  width: 1px;
}

/* End Ribbon horizontal menu */
/* #region Podrobné vyhledávání */
#searchPage #reactSearchInputRoot {
  max-width: 500px;
  width: 100%;
  display: flex;
  justify-content: center;
}
#searchPage #reactDataGridRoot {
  width: 100% !important;
}

/* #endregion Podrobné vyhledávání */
/* #region Sprava obsahu - inline editor článku (mimo dxPopup) */
#articleEditorInline {
  height: 100%;
  overflow: hidden;
}

/*
    Layout bez tabů - přepínání pohledu (HTML editor/Textový editor/Náhled) řeší
    tlačítka v ribbonu (viz \`_ArticleEditorRibbon.cshtml\` a
    \`CurrentTask.setArticleEditorMode\`). Panel metadat vpravo lze skrýt/zobrazit
    úzkým tlačítkem přilepeným na jeho levé hraně (stejný přístup jako sbalování
    stromu složek ve FileManageru - viz \`FileManager.tsx\`/\`file-manager-aside-toggle\`)
    a horizontálně měnit jeho šířku tažením za "resize handle" vlevo od panelu
    (\`ContentManagerTask.handleArticleMetadataResizeStart\`). Sbalený/rozbalený stav
    a šířka se řeší čistě v JS (\`ContentManagerTask.updateArticleMetadataPaneLayout\`),
    tyto styly jen definují vzhled jednotlivých elementů.
*/
.article-editor-inline-layout {
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 0;
}

.article-editor-main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  /* Vizuální okraj hlavního obsahu editoru je "nalepený" přímo na resize handle
     panelu metadat (žádná mezera mezi nimi) - proto border, ne margin. */
  border-right: 1px solid #eee;
}

.article-editor-pane {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
}

.article-editor-pane .jodit-container {
  width: 100%;
  height: 100% !important;
}

/* Panel metadat je trvale viditelný v pravé části hlavního okna - lze jej skrýt
   úzkým tlačítkem \`#articleMetadataAsideToggle\` a horizontálně měnit tažením za
   \`#articleMetadataResizeHandle\` - stejný přístup jako sbalování/resize stromu
   složek ve FileManageru (\`file-manager-aside-toggle\`/\`file-manager-tree-resize-handle\`,
   viz FileManager.css). Sbalení i šířka (\`style.width\`) se nastavují přímo v JS
   (\`ContentManagerTask.updateArticleMetadataPaneLayout\`), třída zde jen definuje
   výchozí vzhled panelu. */
.article-metadata-pane {
  flex: 0 0 auto;
  width: 380px;
  min-height: 0;
  overflow-y: auto;
  padding: 0.5rem 0.75rem;
  border-left: 1px solid #eee;
  /* Panel je úzký - řádky/buňky navržené pro široký popup
     (\`new-popup-row\`/\`new-popup-cell\` vedle sebe) se v tomto panelu řadí
     pod sebe, aby se prvky nemačkaly do jednoho úzkého sloupce. */
}
.article-metadata-pane .new-popup-row {
  flex-direction: column;
  gap: 8px;
  padding: 0 0 15px;
}
.article-metadata-pane .new-popup-cell {
  width: 100% !important;
}
.article-metadata-pane .new-popup-cell .dx-widget {
  width: 100% !important;
}
.article-metadata-pane .new-popup-cell:has(div.dx-button) {
  align-self: stretch;
}
.article-metadata-pane .new-popup-cell.mt-auto {
  margin-top: 0 !important;
}

/* Resize handle panelu metadat - stejný vzhled/chování jako
   \`.file-manager-tree-resize-handle\` ve FileManageru (viz FileManager.css). */
.article-metadata-resize-handle {
  width: 5px;
  flex-shrink: 0;
  cursor: col-resize;
  background-color: transparent;
  transition: background-color 0.15s ease;
}

.article-metadata-resize-handle:hover {
  background-color: #c0d0e0;
}

/* Úzké sbalovací tlačítko panelu metadat - stejný vzhled jako
   \`.file-manager-aside-toggle\` ve FileManageru, jen zrcadlově (panel je vpravo,
   ne vlevo). Nalepené na obě strany bez mezery - vlevo na resize handle (tvoří
   s ním vizuálně souvislý pruh), vpravo přímo na okraj panelu metadat. */
.article-metadata-aside-toggle {
  align-self: flex-start;
  width: 14px;
  height: 28px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #002B59;
  background-color: #f0f4fa;
  border: 1px solid #d0d0d0;
  border-right: none;
  cursor: pointer;
  margin-top: 8px;
  z-index: 1;
}

.article-metadata-aside-toggle:hover {
  background-color: #e7f1ff;
}

/* Náhled článku - přepíná se tlačítky v ribbonu (viz setArticleEditorMode) -
   vykreslí se přímo do hlavního okna editoru namísto popupu/nového okna. */
.article-preview-pane {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0.5rem 0;
}

/* #endregion */
/* #region Sdílený WYSIWYG HTML editor v ribbonu (viz Scripts/Shared/HtmlRichTextEditor) -
   obecný styl, použitelný pro libovolné použití editoru v aplikaci, nejen Content Manager */
/* Kontejner toolbaru editoru vykresleného do ribbonu - viz
   HtmlRichTextEditorRibbonRenderer.render(). V "native" režimu (Jodit) sem knihovna
   vykreslí svůj vlastní toolbar (toolbar: HTMLElement), zde se jen potlačí jeho
   vlastní rámeček/pozadí, aby zapadl do vzhledu ribbonu. */
.html-rich-text-editor-ribbon-toolbar {
  width: 100%;
}

.html-rich-text-editor-ribbon-toolbar .jodit-toolbar-editor-collection {
  background-color: transparent;
  border: none;
  padding: 0;
}

.html-rich-text-editor-ribbon-toolbar .jodit-toolbar__box {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

/* Styl tlačítek pro "commands" fallback režim (viz HtmlRichTextEditorRibbonRenderer) -
   používá se jen pro implementace editoru bez podpory nativního toolbaru v cizím
   kontejneru; pro Jodit (native режим) se tyto třídy nevyužívají. */
.rh-function-editor-group {
  display: flex;
  align-items: center;
  gap: 4px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.rh-function-editor-separator {
  width: 1px;
  height: 24px;
  background-color: #ccc;
  margin: 0 4px;
}

/* Velikost ikony/textu sjednocená s klasickým ribbonem (viz .rh-function-item .icon
   výše v souboru) - editor toolbar má vypadat vizuálně stejně dominantně jako běžné
   ribbon položky, ne jako drobné pomocné ikony. */
.rh-function-editor-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 4px 6px;
  cursor: pointer;
  font-size: 10.7px;
  min-width: 50px;
}
.rh-function-editor-item .icon {
  height: 25px;
  width: 25px;
  margin: 0 auto;
  flex: 0 0 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rh-function-editor-item .icon .bi {
  font-size: 25px;
  line-height: 1;
}
.rh-function-editor-item .text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  width: min-content;
  max-width: 100%;
  overflow: hidden;
  overflow-wrap: normal;
  text-overflow: ellipsis;
}

.rh-function-editor-item:hover {
  background-color: #e8e8e8;
}

.rh-function-editor-item-active {
  background-color: #e8e8e8;
}

.rh-function-editor-item:disabled {
  opacity: 0.4;
  cursor: default;
}

.rh-function-editor-trigger {
  position: absolute;
  right: 3px;
  bottom: 4px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
  opacity: 0.6;
}

/* Split tlačítko (kind:"split" - odrážky/číslování): hlavní ikona provede přímou akci
   (toggle), samostatná šipka vedle ní rozbalí nabídku stylů (viz
   HtmlRichTextEditorToolbarRenderer.createSplitCommandButton a
   JoditToolbarCommandFactory - control.list u ul/ol). */
.rh-function-editor-split {
  display: flex;
  align-items: stretch;
  border: none;
}

.rh-function-editor-split .rh-function-editor-split-main {
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 4px 4px 6px;
  cursor: pointer;
  font-size: 11px;
}

.rh-function-editor-split .rh-function-editor-split-main:hover {
  background-color: #e8e8e8;
}

.rh-function-editor-split .rh-function-editor-split-main.rh-function-editor-item-active {
  background-color: #e8e8e8;
}

.rh-function-editor-split-arrow {
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  padding: 0;
  cursor: pointer;
  color: inherit;
}

.rh-function-editor-split-arrow:hover {
  background-color: #e8e8e8;
}

.rh-function-editor-split-arrow .rh-function-editor-trigger {
  position: static;
  border-top-color: currentColor;
  opacity: 0.7;
}

/* Vlastní popup ukotvený k tlačítku ribbonu editoru (viz AnchoredPopup.ts) - obaluje se
   do Joditových tříd .jodit-popup/.jodit-popup__content (viz jodit.min.css, importováno
   přes JoditHtmlRichTextEditor.ts), takže dodatečné pozadí/stín/padding zajišťuje sám
   Jodit; zde jen doladíme rozestupy a scroll dlouhých seznamů. */
.html-rich-text-editor-popup .html-rich-text-editor-popup-content {
  max-height: 320px;
  overflow-y: auto;
}

.html-rich-text-editor-popup-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.html-rich-text-editor-popup-item {
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  cursor: pointer;
}
.html-rich-text-editor-popup-item .jodit-toolbar-button__text {
  display: block;
  width: 100%;
}

/* Ribbon během editace/vytváření článku - server-rendered partial
   \`_ArticleEditorRibbon.cshtml\`, který dodržuje stejnou strukturu jako standardní
   funkční ribbon Content Manageru (.rh-function > .rh-function-group >
   .rh-function-group-items > .rh-function-item), takže výška
   (\$ribbon-function-total-height) a vzhled zůstávají shodné s "normálním"
   zobrazením ribbonu - mění se jen jeho obsah (Uložit/Zrušit, přepínání pohledu
   a toolbar editoru; skrývání/resize metadat je od tlačítek v ribbonu přesunuté
   přímo k panelu metadat, viz \`.article-metadata-aside-toggle\`/
   \`.article-metadata-resize-handle\` výše). */
.article-editor-ribbon-toolbar-group {
  flex: 1 1 auto;
  min-width: 0;
}

.article-editor-ribbon-toolbar-wrapper {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
}

/* #region AdminUserRole */
.admin-user-role-action-column {
  width: 220px;
}

.admin-user-role-roles-column {
  min-height: 519.5px;
  display: flex;
  flex-direction: column;
}

.admin-user-role-default-role {
  margin-top: auto;
}

/* #endregion AdminUserRole */
/* #region PublishingTasks - ribbonové vyhledávání */
.publishingTasksSearchGroup .mainRibbonSubGroupContainer {
  height: 80px;
  min-height: 80px;
  display: inline-flex;
  align-items: center;
  padding: 0;
  width: max-content;
}
.publishingTasksSearchGroup .mainRibbonSubGroup {
  margin-left: 8px;
  margin-right: 8px;
  list-style: none;
}
.publishingTasksSearchGroup .publishingTasksSearchContainer {
  display: flex;
  align-items: center;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer {
  width: auto;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input {
  width: auto;
  max-width: none;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input form {
  display: flex;
  align-items: center;
  width: auto;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer .input-group {
  width: 280px;
  padding-inline: 0;
  display: flex;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input-filters {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0;
  margin-left: 8px;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer .form-check {
  margin: 0;
  white-space: nowrap;
  font-size: small;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer .form-check-input {
  margin-top: 0;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input-field .form-control {
  height: 26px;
  font-size: 13px;
}
.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input-submit .btn {
  height: 26px;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.publishingTasksSearchGroup .mainRibbonSubModule {
  text-align: center;
  color: var(--companyGray);
  border-top: 1px solid rgba(0, 0, 0, 0.0392156863);
  padding: 2px 5px;
  overflow: hidden;
  white-space: nowrap;
  font-size: 0.8em;
}

/* #region PublishingTasks */
#searchInputComponent .form-check {
  font-size: large;
}
`, "",{"version":3,"sources":["webpack://./wwwroot/css/Ppd.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB,oBAAoB;AACpB;EACE,qCAAqC;EACrC,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB,kBAAkB;AAClB;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB,wBAAwB;AACxB;EACE,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;AACtC;;AAEA;;EAEE,YAAY;AACd;;AAEA,sBAAsB;AACtB,kBAAkB;AAClB;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB,uBAAuB;AACvB;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B,uBAAuB;AACvB;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,4CAA4C;EAC5C,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B,qBAAqB;AACrB;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB,qBAAqB;AACrB;;EAEE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB,kBAAkB;AAClB;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB,mBAAmB;AACnB;EACE,wDAAwD;AAC1D;AACA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB,kBAAkB;AAClB;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC,uBAAuB;AACvB,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA,mBAAmB;AACnB,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,2DAA2D;EAC3D,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,4CAA4C;EAC5C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,0EAA0E;AAC5E;;AAEA;EACE,uCAAuC;EACvC,YAAY;AACd;AACA;EACE,sEAAsE;AACxE;AACA;EACE,sEAAsE;AACxE;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,oEAAoE;AACtE;AACA;EACE,oEAAoE;AACtE;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,uCAAuC;AACzC;AACA;EACE,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,yBAAyB;AACzB,iBAAiB;AACjB;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;AACf;AACA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB,0BAA0B;AAC1B,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC,qBAAqB;AACrB;EACE,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wBAAwB;AACxB,gCAAgC;AAChC,0BAA0B;AAC1B;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B,yBAAyB;AACzB,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B,yBAAyB;AACzB,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B,iCAAiC;AACjC;EACE,8CAA8C;EAC9C,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,aAAa;EACb,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,+DAA+D;EAC/D,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,UAAU;EACV,0CAA0C;EAC1C,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uCAAuC;AACzC;AACA;;EAEE,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;EACd;;;+DAG6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;EACjD,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,UAAU;EACV,cAAc;EACd,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA,+BAA+B;AAC/B,iCAAiC;AACjC;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC,gEAAgE;AAChE;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;;;;;;CAUC;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB;yEACuE;EACvE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;;;;;;2BAM2B;AAC3B;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B;;kEAEgE;AAClE;AACA;EACE,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA;8EAC8E;AAC9E;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;yEAGyE;AACzE;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;2EAC2E;AAC3E;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;4FAC4F;AAC5F;;;2DAG2D;AAC3D;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;oEAEoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;AACd;;AAEA;;;wDAGwD;AACxD;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;;iEAGiE;AACjE;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;;;6CAQ6C;AAC7C;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B,oDAAoD;AACpD;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB","sourcesContent":["@charset \"UTF-8\";\r\n:root {\r\n  --green: #82bc00;\r\n  --greenDark: #699900;\r\n  --greenSelected: #4E7300;\r\n  --yellow: #FAC239;\r\n  --yellowDark: #faa800;\r\n  --yellowSelected: #D48D00;\r\n  --red: #e40039;\r\n  --redDark: #B0002C;\r\n  --redSelected: #7D001F;\r\n  --blue: #00a1e0;\r\n  --blueDark: #002b59;\r\n}\r\n\r\n/* #region Colors */\r\n/* #region Buttons */\r\n.btn-primary {\r\n  background-color: var(--primaryColor);\r\n  border-color: var(--primaryColor);\r\n  color: #fff;\r\n}\r\n.btn-primary:hover {\r\n  background-color: #00162e;\r\n  border-color: #00162e;\r\n}\r\n\r\n.btn-warning {\r\n  color: #fff;\r\n  background-color: var(--yellowDark) !important;\r\n  border-color: var(--yellowDark) !important;\r\n}\r\n.btn-warning:hover {\r\n  color: #fff;\r\n  background-color: var(--yellow) !important;\r\n  border-color: var(--yellow) !important;\r\n}\r\n\r\n.btn-success {\r\n  color: #fff;\r\n  background-color: var(--green) !important;\r\n  border-color: var(--green) !important;\r\n}\r\n.btn-success:hover {\r\n  color: #fff;\r\n  background-color: var(--greenDark) !important;\r\n  border-color: var(--greenDark) !important;\r\n}\r\n\r\n.btn-danger {\r\n  color: #fff;\r\n  background-color: var(--red) !important;\r\n  border-color: var(--red) !important;\r\n}\r\n.btn-danger:hover {\r\n  color: #fff;\r\n  background-color: var(--redDark) !important;\r\n  border-color: var(--redDark) !important;\r\n}\r\n\r\n.btn-info {\r\n  color: #fff;\r\n  background-color: var(--blue) !important;\r\n  border-color: var(--blue) !important;\r\n}\r\n.btn-info:hover {\r\n  color: #fff;\r\n  background-color: var(--blueDark) !important;\r\n  border-color: var(--blueDark) !important;\r\n}\r\n\r\n.btn-link {\r\n  color: var(--supplementaryColor);\r\n  text-decoration: underline;\r\n  border: none;\r\n  background: none;\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n.btn-link:hover {\r\n  color: var(--secondaryColor);\r\n}\r\n\r\n.btn-disabled {\r\n  background: #cecece !important;\r\n  border-color: #cecece !important;\r\n  box-shadow: none;\r\n  color: #737373 !important;\r\n}\r\n\r\n.dx-button.dx-state-disabled .dx-button-text,\r\n.dx-button.dx-state-disabled .dx-icon {\r\n  color: rgba(0, 0, 0, 0.87);\r\n}\r\n\r\n/* #endregion Buttons */\r\n/* #region Texts */\r\n.text-warning {\r\n  color: var(--yellowDark) !important;\r\n}\r\n\r\n.text-success {\r\n  color: var(--green) !important;\r\n}\r\n\r\n.text-danger {\r\n  color: var(--red) !important;\r\n}\r\n\r\n/* #endregion Texts */\r\n/* #region Backgrounds */\r\n.bg-warning {\r\n  background-color: var(--yellowDark) !important;\r\n  color: #fff;\r\n}\r\n\r\n.bg-success {\r\n  background-color: var(--green) !important;\r\n  color: #fff;\r\n}\r\n\r\n.bg-danger {\r\n  background-color: var(--red) !important;\r\n  color: #fff;\r\n}\r\n\r\n.bg-info {\r\n  background-color: var(--blue) !important;\r\n}\r\n\r\n/* #endregion Backgrounds */\r\n.dx-texteditor.dx-editor-filled.dx-state-disabled, .dx-texteditor.dx-editor-filled.dx-state-readonly, .dx-texteditor.dx-editor-filled.dx-state-readonly.dx-state-hover {\r\n  background-color: rgb(245, 245, 245);\r\n}\r\n\r\n.dx-state-disabled .dx-widget,\r\n.dx-state-disabled.dx-widget {\r\n  opacity: 0.5;\r\n}\r\n\r\n/* #endregion Colors */\r\n/* #region Basis */\r\na {\r\n  color: var(--supplementaryColor);\r\n}\r\na:hover {\r\n  color: var(--secondaryColor);\r\n}\r\n\r\n.content {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n  padding: 1rem 1.5rem;\r\n  overflow: auto;\r\n}\r\n\r\n.content-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: 100%;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.content-cell {\r\n  padding: 0.25rem;\r\n}\r\n\r\n.dx-item.dx-radiobutton {\r\n  margin: 0 0 1px;\r\n}\r\n\r\n.label,\r\n.dx-label span {\r\n  font-weight: bold;\r\n}\r\n\r\n.label-disabled {\r\n  color: #b6b6b6 !important;\r\n}\r\n\r\n.highlight {\r\n  background-color: var(--yellow);\r\n}\r\n\r\n.content-cell-tiles {\r\n  flex: 80;\r\n}\r\n\r\n.content-cell-tiles-expand {\r\n  padding-right: 16px;\r\n}\r\n\r\n[hidden] {\r\n  display: none;\r\n}\r\n\r\n.dx-scrollable {\r\n  width: 100%;\r\n}\r\n\r\n.btn {\r\n  text-transform: uppercase;\r\n  border-radius: 4px;\r\n}\r\n\r\n.row > * {\r\n  width: auto;\r\n}\r\n\r\n.separator {\r\n  border-top: 1px solid var(--primaryColor);\r\n  margin: 0.25rem 0 0.75rem;\r\n}\r\n\r\n/* #endregion Basis */\r\n/* #region Nezarazene */\r\n.custom-icon svg {\r\n  height: 20px;\r\n  width: 16px;\r\n  margin-top: -5px;\r\n}\r\n\r\n.toggler-down::after {\r\n  content: \"\";\r\n  display: inline-block;\r\n  margin: 2px 0;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-top: 1px solid black;\r\n  border-right: 1px solid black;\r\n  -moz-transform: rotate(135deg);\r\n  -webkit-transform: rotate(135deg);\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.toggler-up::after {\r\n  content: \"\";\r\n  display: inline-block;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-top: 1px solid black;\r\n  border-right: 1px solid black;\r\n  -moz-transform: rotate(-45deg);\r\n  -webkit-transform: rotate(-45deg);\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n.dx-fileuploader-container .dx-fileuploader-cancel-button {\r\n  border-color: transparent;\r\n}\r\n.dx-fileuploader-container .dx-fileuploader-cancel-button .dx-icon.dx-icon-close {\r\n  color: var(--requiredMarkColor);\r\n}\r\n\r\n.dx-fileuploader-wrapper {\r\n  padding: 0;\r\n}\r\n\r\n.form-item {\r\n  padding: 0.25rem 1.5rem 0.5rem 0;\r\n}\r\n\r\n.dx-radiobutton-icon::after {\r\n  content: none;\r\n}\r\n\r\n.ellipsis-3-rows {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.dx-collection > hr {\r\n  margin: 5px 0 5px 0;\r\n}\r\n\r\n.mainRibbonContainer #mainRibbon-container .dx-multiview-wrapper .mainRibbonGroupContainer .mainRibbonGroup .mainRibbonSubGroupContainer .mainRibbonSubGroup #ribBtnfnClearFilter {\r\n  margin-top: 18px;\r\n}\r\n\r\n#login .buttonGroup .dx-box-item {\r\n  flex: unset !important;\r\n}\r\n\r\n.u-no-max-size {\r\n  max-height: none !important;\r\n  max-width: none !important;\r\n}\r\n\r\n/* #endregion Nezarazene */\r\n/* #region MainRibbon */\r\n.mainRibbonContainer .dx-label span {\r\n  font-weight: normal;\r\n}\r\n.mainRibbonContainer .menu-subcell-date-only {\r\n  list-style: none;\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n}\r\n.mainRibbonContainer #rangePickerInput {\r\n  height: 26px;\r\n  width: 170px;\r\n  background-color: rgba(0, 0, 0, 0.04);\r\n  border: none;\r\n  border-bottom: 1px solid var(--primaryColor);\r\n  border-top-left-radius: 4px;\r\n  border-top-right-radius: 4px;\r\n  border-bottom-left-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  font-size: 13px;\r\n}\r\n.mainRibbonContainer .menu-subcell-date {\r\n  list-style: none;\r\n  align-self: end;\r\n}\r\n.mainRibbonContainer .menu-subcell-orderBy {\r\n  list-style: none;\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n  margin-top: 15px;\r\n}\r\n.mainRibbonContainer .menu-subcell-orderBy-sort {\r\n  list-style: none;\r\n  margin-top: 17px;\r\n  margin-right: 8px;\r\n}\r\n.mainRibbonContainer .menu-subcell-id {\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n  list-style: none;\r\n  margin-right: 15px;\r\n}\r\n.mainRibbonContainer .menu-subcell-search {\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n  list-style: none;\r\n}\r\n.mainRibbonContainer .menu-subcell-add {\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n}\r\n.mainRibbonContainer .menu-subcell-countdown {\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n  list-style: none;\r\n  white-space: pre-wrap;\r\n  text-align: center;\r\n  min-width: 150px;\r\n}\r\n.mainRibbonContainer .menu-subcell-clearbtn {\r\n  list-style: none;\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n}\r\n.mainRibbonContainer #btnDayUp, .mainRibbonContainer #btnDayDown {\r\n  margin: 2px;\r\n}\r\n.mainRibbonContainer #btnDayUp.dx-button-has-icon, .mainRibbonContainer #btnDayDown.dx-button-has-icon {\r\n  min-width: 25px;\r\n}\r\n.mainRibbonContainer #btnDayUp .dx-button-content, .mainRibbonContainer #btnDayDown .dx-button-content {\r\n  padding-block: 5px;\r\n  -webkit-padding-start: 5px;\r\n  padding-inline-start: 5px;\r\n  -webkit-padding-end: 5px;\r\n  padding-inline-end: 5px;\r\n}\r\n.mainRibbonContainer .menu-subcell {\r\n  list-style: none;\r\n}\r\n\r\n/* #endregion MainRibbon */\r\n/* #region HomeTile */\r\n.tilesContainer #Tile_2_1_ContentsWrapper {\r\n  max-height: 400px;\r\n}\r\n.tilesContainer #Tile_2_2_ContentsWrapper {\r\n  max-height: 400px;\r\n}\r\n\r\n/* #endregion HomeTile */\r\n/* #region DataGrid */\r\n.dx-datagrid .dx-row > td,\r\n.dx-datagrid .dx-datagrid-table .dx-header-row > td {\r\n  padding: 5px 11px;\r\n}\r\n.dx-datagrid .dx-row:not(.dx-master-detail-row) > td .btn-sm {\r\n  padding: 2px 5px;\r\n  font-size: 11px;\r\n}\r\n.dx-datagrid .dx-row-lines > td {\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.dx-datagrid-content .dx-datagrid-table .dx-row:not(.dx-master-detail-row) > td:last-child,\r\n.dx-datagrid-content .dx-datagrid-table .dx-row:not(.dx-master-detail-row) > td:nth-child(7),\r\n.dx-datagrid-content .dx-datagrid-table .dx-row:not(.dx-master-detail-row) > td:nth-child(8) {\r\n  padding: 2px 11px;\r\n}\r\n\r\n.dx-datagrid-content .dx-datagrid-table .dx-row td {\r\n  height: 31px;\r\n}\r\n\r\n.btn-same-width {\r\n  width: 60px;\r\n}\r\n\r\n.btn-same-width-lg {\r\n  width: 125px;\r\n}\r\n\r\n#dataGridMasterDetailContainer {\r\n  height: 100%;\r\n}\r\n\r\n#editGridpartial {\r\n  width: 100%;\r\n}\r\n#editGridpartial .dx-toolbar-after {\r\n  width: 100% !important;\r\n  padding: 0 !important;\r\n}\r\n#editGridpartial .dx-datagrid-search-panel {\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n#gridZjisteni .dx-toolbar-after {\r\n  width: 100% !important;\r\n  padding: 0 !important;\r\n}\r\n#gridZjisteni .dx-datagrid-search-panel {\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n#orgStrTreeList .dx-treelist-header-panel {\r\n  width: 100%;\r\n  padding: 0;\r\n}\r\n#orgStrTreeList .dx-treelist-header-panel .dx-toolbar-after {\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n#orgStrTreeList .dx-treelist-header-panel .dx-treelist-search-panel {\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n/* #endregion DataGrid */\r\n/* #region Toast */\r\n.dx-toast-content {\r\n  right: 0.5rem;\r\n  left: auto !important;\r\n  bottom: 0.75rem;\r\n  top: auto !important;\r\n  transform: none !important;\r\n}\r\n\r\n/* #endregion Toast */\r\n/* #region Detail */\r\n.dx-master-detail-cell {\r\n  background-color: rgba(0, 0, 0, 0.1019607843) !important;\r\n}\r\n.dx-master-detail-cell .detail {\r\n  padding: 0;\r\n}\r\n\r\n.detail {\r\n  min-height: 280px;\r\n  min-width: 400px;\r\n  padding: 0.5rem 0.75rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* #region Radek s tlacitky */\r\n.detail > .title {\r\n  margin-bottom: 8px;\r\n  flex-grow: 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.title-bar {\r\n  margin-left: auto;\r\n}\r\n.title-bar > .title {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-right: 40px;\r\n}\r\n.title-bar > .actions {\r\n  margin-left: auto;\r\n  display: flex;\r\n  -webkit-flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n.title-bar > .actions .dx-button .dx-button-content {\r\n  padding: 6px 12px;\r\n}\r\n.title-bar > .actions .btn {\r\n  padding: 3px 12px;\r\n  font-size: 12px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);\r\n}\r\n\r\n/* #endregion Radek s tlacitky */\r\n.detail-content-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: 100%;\r\n}\r\n.detail-content-row > .content-cell {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  flex-direction: column;\r\n}\r\n\r\n.detail-text-content {\r\n  text-wrap: pretty;\r\n}\r\n.detail-text-content div {\r\n  white-space: normal;\r\n  padding: 0 4px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.detail-row {\r\n  display: flex;\r\n  position: relative;\r\n  gap: 100px;\r\n  padding-top: 0.25rem;\r\n}\r\n.detail-row > .cell {\r\n  min-width: 160px;\r\n  display: flex;\r\n  width: 30%;\r\n  align-items: center;\r\n  border-bottom: 1px solid #EFF2F5;\r\n  margin-bottom: 10px;\r\n}\r\n.detail-row > .cell .label {\r\n  padding-left: 0.25rem;\r\n  margin-right: 10px;\r\n}\r\n.detail-row .title-part {\r\n  margin: 1.5rem 0.25rem 0.5rem;\r\n  font-weight: bold;\r\n  font-size: 1.1em;\r\n}\r\n.detail-row > .empty-cell {\r\n  min-width: 160px;\r\n  display: flex;\r\n  width: 30%;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n.detail-row > .only-one-cell {\r\n  min-width: 160px;\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n  border-bottom: 1px solid #EFF2F5;\r\n  margin-bottom: 10px;\r\n}\r\n.detail-row > .only-one-cell .label {\r\n  padding-left: 0.25rem;\r\n  margin-right: 10px;\r\n}\r\n\r\n.detail-row-buttons {\r\n  display: flex;\r\n  padding-top: 0.5rem;\r\n  position: fixed;\r\n  bottom: 0;\r\n  padding-bottom: 15px;\r\n  width: 96%;\r\n  background-color: white;\r\n}\r\n.detail-row-buttons .button {\r\n  margin-right: 1rem;\r\n}\r\n\r\n.detail-row-buttons-gap {\r\n  padding-top: 40px;\r\n}\r\n\r\n.cell-description {\r\n  display: inline-table;\r\n  width: 75%;\r\n}\r\n.cell-description > .popis {\r\n  color: var(--redDark);\r\n}\r\n.cell-description > .vlivy {\r\n  color: var(--red);\r\n}\r\n\r\n.detail-duplicity-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  padding-bottom: 30px;\r\n  gap: 30px;\r\n}\r\n\r\n.duplicity-cell {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.detail-duplicity-cell {\r\n  font-weight: bold;\r\n}\r\n\r\n.pagination-bar {\r\n  display: flex;\r\n  flex-direction: row;\r\n  position: relative;\r\n  gap: 100px;\r\n}\r\n\r\n.history-record-loader-show,\r\n.history-record-loader-hide,\r\n.duplicity-record-loader-show,\r\n.duplicity-record-loader-hide {\r\n  padding-top: 0.25rem;\r\n}\r\n\r\n.history-record-loader-show .dx-button,\r\n.history-record-loader-hide .dx-button,\r\n.duplicity-record-loader-show .dx-button,\r\n.duplicity-record-loader-hide .dx-button {\r\n  height: auto;\r\n}\r\n\r\n.history-record-loader-show .dx-button-content,\r\n.history-record-loader-hide .dx-button-content,\r\n.duplicity-record-loader-show .dx-button-content,\r\n.duplicity-record-loader-hide .dx-button-content {\r\n  font-size: 0.9em;\r\n}\r\n\r\n.history {\r\n  padding-left: 8px;\r\n  padding-top: 20px;\r\n  width: 45%;\r\n}\r\n.history button {\r\n  border: none;\r\n  background-color: #eaeaea;\r\n}\r\n\r\n.history-record {\r\n  font-size: 11px;\r\n}\r\n.history-record button {\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.history-record-hidden {\r\n  display: none;\r\n}\r\n\r\n.answer-record {\r\n  font-size: 11px;\r\n}\r\n.answer-record button {\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.duplicity {\r\n  padding-left: 8px;\r\n  padding-top: 20px;\r\n  position: inherit;\r\n  width: 45%;\r\n}\r\n.duplicity button {\r\n  border: none;\r\n  background-color: transparent;\r\n}\r\n\r\n.duplicity-record {\r\n  font-size: 11px;\r\n}\r\n\r\n.duplicity-record-hidden {\r\n  display: none;\r\n}\r\n\r\n.detail-toggle-button {\r\n  font-size: 11px;\r\n  padding: 2px 5px;\r\n}\r\n.detail-toggle-button span {\r\n  margin-left: 3px;\r\n}\r\n\r\n/* #endregion Detail */\r\n/* #region PopUp */\r\n.newRecord div {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.time-row {\r\n  background-color: #efefef;\r\n  padding: 0px 5px 15px;\r\n}\r\n\r\n.cell-invoices {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n}\r\n\r\n.new-popup-cell-input-required .dx-texteditor::before {\r\n  border-bottom: 2px solid var(--secondaryColor);\r\n  transform: scale(1);\r\n}\r\n.new-popup-cell-input-required .dx-label span::after {\r\n  content: \" *\";\r\n  color: var(--secondaryColor);\r\n}\r\n\r\n.new-popup-cell-file-required .dx-fileuploader-button {\r\n  border: 2px solid var(--secondaryColor);\r\n}\r\n.new-popup-cell-file-required .dx-fileuploader-button span::after {\r\n  content: \" *\";\r\n  color: var(--secondaryColor);\r\n}\r\n\r\n.new-popup-cell:has(div.dx-button) {\r\n  align-self: end;\r\n}\r\n\r\n.new-popup-cell:has(div div.dx-checkbox) {\r\n  align-self: center;\r\n}\r\n\r\n.new-popup-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  padding: 0px 5px 15px;\r\n}\r\n\r\n.new-popup-cell-label {\r\n  font-weight: bold;\r\n}\r\n\r\n.history-popup-container {\r\n  display: grid;\r\n}\r\n\r\n.history-popup-row {\r\n  display: flex;\r\n}\r\n\r\n.history-popup-cell {\r\n  padding: 0 0.25rem;\r\n}\r\n\r\n.history-popup-cell-input {\r\n  padding: 0 0.25rem;\r\n}\r\n\r\n.history-popup-cell-input-diff {\r\n  color: var(--red);\r\n}\r\n\r\n.history-popup-main-content {\r\n  display: grid;\r\n  grid-template-columns: 1fr 2fr 2fr;\r\n  width: 100%;\r\n}\r\n\r\n.history-popup-main-content-same-column {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  width: 100%;\r\n}\r\n\r\nins {\r\n  background-color: var(--green);\r\n}\r\n\r\ndel {\r\n  background-color: #ffefc7;\r\n}\r\n\r\n.dx-popup-content:has(.detail) .detail {\r\n  padding: 0;\r\n}\r\n\r\n/* #endregion PopUp */\r\n.popup-map-div {\r\n  min-height: calc(100vh - 400px);\r\n}\r\n.popup-map-div #mapDiv {\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n/* #region Publikační úlohy */\r\n#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-toolbar.dx-filemanager-general-toolbar {\r\n  left: 0;\r\n  min-width: 0;\r\n}\r\n#fileManagerPublishingTasksContainer.search-mode .dx-toolbar-items-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n#fileManagerPublishingTasksContainer.search-mode .dx-toolbar-before {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n#fileManagerPublishingTasksContainer.search-mode .dx-toolbar-after {\r\n  flex: 0 0 auto;\r\n  margin-left: 8px;\r\n}\r\n#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs .dx-menu-item-wrapper,\r\n#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs .dx-breadcrumbs-item,\r\n#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs .dx-breadcrumbs-separator {\r\n  display: none !important;\r\n}\r\n#fileManagerPublishingTasksContainer.search-mode .dx-filemanager-breadcrumbs .custom-search-caption {\r\n  display: block;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  line-height: 32px;\r\n  position: relative;\r\n  top: -16px;\r\n}\r\n#fileManagerPublishingTasksContainer .dx-filemanager-dirs-tree .dx-treeview-item-content i.dx-icon {\r\n  align-self: center;\r\n}\r\n#fileManagerPublishingTasksContainer .dx-filemanager-dirs-tree .dx-treeview-item-content span.dx-filemanager-dirs-tree-item-text {\r\n  white-space: normal;\r\n}\r\n#fileManagerPublishingTasksContainer .dx-filemanager-toolbar.dx-filemanager-general-toolbar {\r\n  position: absolute;\r\n  right: 0;\r\n  background-color: transparent;\r\n  min-width: 100px;\r\n  z-index: 1;\r\n}\r\n#fileManagerPublishingTasksContainer .dx-filemanager-toolbar.dx-filemanager-general-toolbar > .dx-toolbar {\r\n  width: 100%;\r\n  background-color: transparent;\r\n}\r\n#fileManagerPublishingTasksContainer .dx-filemanager-dirs-panel {\r\n  border-right: 1px solid #ccc;\r\n}\r\n#fileManagerPublishingTasksContainer .dx-datagrid-table .dx-row {\r\n  border-bottom: 1px solid #eee;\r\n}\r\n#fileManagerPublishingTasksContainer .dx-datagrid-table .dx-row:nth-child(even) {\r\n  background-color: rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.viewport:has(#fileManagerPublishingTasksContainer) .overlay-view {\r\n  border-left: none !important;\r\n  border-top: 1px solid #ccc;\r\n}\r\n\r\n/* #endregion Publikační úlohy */\r\n/* #region Popis site */\r\n/* #region Mapa */\r\n.mapa-search-display-mode {\r\n  display: flex;\r\n  gap: 18px;\r\n  margin-top: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.mapa-search-display-mode-item {\r\n  display: flex;\r\n  gap: 5px;\r\n  align-items: center;\r\n  margin: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n#mapaTrackContextMenu {\r\n  position: fixed;\r\n  display: none;\r\n  min-width: 190px;\r\n  padding: 4px;\r\n  background: #fff;\r\n  border: 1px solid #c8c8c8;\r\n  border-radius: 3px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.22);\r\n  z-index: 14000;\r\n}\r\n#mapaTrackContextMenu button {\r\n  width: 100%;\r\n  padding: 7px 10px;\r\n  border: 0;\r\n  background: transparent;\r\n  text-align: left;\r\n  white-space: nowrap;\r\n}\r\n#mapaTrackContextMenu button:hover, #mapaTrackContextMenu button:focus {\r\n  background: #f0f0f0;\r\n  outline: none;\r\n}\r\n\r\n/* #endregion Mapa*/\r\n/* #region Trate */\r\n.track-region {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.region-header {\r\n  margin: 0.75px 0 0.5rem;\r\n  padding: 0 0.5rem;\r\n  color: var(--secondaryColor);\r\n  border-bottom: 3px solid var(--secondaryColor);\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.region-header-text {\r\n  font-weight: 700;\r\n}\r\n.region-header-buttons {\r\n  display: flex;\r\n  height: 28px;\r\n  padding-right: 16px;\r\n  gap: 8px;\r\n}\r\n\r\n.track-container {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  margin: 1.5rem auto 1rem;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.track-stats {\r\n  width: 100%;\r\n  padding: 0.25rem 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n  border-radius: 4px;\r\n  border: 2px solid transparent;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.track-stats.okay {\r\n  background-color: color-mix(in srgb, var(--green), white 50%);\r\n  color: var(--greenSelected);\r\n  border-color: var(--greenSelected);\r\n}\r\n.track-stats.not-okay {\r\n  background-color: color-mix(in srgb, var(--red), white 50%);\r\n  color: var(--redSelected);\r\n  border-color: var(--redSelected);\r\n}\r\n.track-stats .stat-icon {\r\n  border: 0.5px solid;\r\n  border-radius: 50%;\r\n  width: 1.7rem;\r\n  height: 1.7rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 1rem;\r\n  flex-shrink: 0;\r\n}\r\n.track-stats .stat-icon i {\r\n  font-size: 1.2rem;\r\n}\r\n.track-stats .stat-info {\r\n  overflow-y: auto;\r\n  height: 2.2rem;\r\n  align-content: center;\r\n}\r\n\r\n.track-group {\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  margin: 0 0.5rem 0.75rem;\r\n}\r\n\r\n.track-header {\r\n  background-color: var(--primaryColor);\r\n  padding: 0.5rem 1rem;\r\n  border-bottom: 2px solid var(--primaryColor);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.track-header-text {\r\n  color: white;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n.track-header-buttons {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.track-item {\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid #eee;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  transition: background-color 0.15s ease;\r\n}\r\n.track-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.track-item:hover, .track-item:focus-within {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n.track-item:nth-of-type(odd) {\r\n  background-color: rgba(0, 0, 0, 0.04);\r\n}\r\n.track-item:nth-of-type(odd):hover {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.track-info {\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1;\r\n}\r\n\r\n.track-number {\r\n  font-weight: bold;\r\n  color: var(--primaryColor);\r\n  margin-right: 15px;\r\n  min-width: 60px;\r\n  font-size: 14px;\r\n}\r\n\r\n.track-name {\r\n  color: #333;\r\n  font-size: 14px;\r\n}\r\n\r\n.track-buttons {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.btn-track {\r\n  padding: 3px 13px;\r\n  border: 2px solid transparent;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n.btn-track:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n  pointer-events: none;\r\n}\r\n\r\n.btn-track-detail {\r\n  background-color: var(--supplementaryColor);\r\n  color: white;\r\n}\r\n.btn-track-detail:hover, .btn-track-detail:focus {\r\n  background-color: color-mix(in srgb, var(--supplementaryColor), black 17%);\r\n}\r\n.btn-track-detail:active {\r\n  background-color: color-mix(in srgb, var(--supplementaryColor), black 30%);\r\n}\r\n\r\n.btn-track-pdf {\r\n  background-color: var(--secondaryColor);\r\n  color: white;\r\n}\r\n.btn-track-pdf:hover, .btn-track-pdf:focus {\r\n  background-color: color-mix(in srgb, var(--secondaryColor), black 17%);\r\n}\r\n.btn-track-pdf:active {\r\n  background-color: color-mix(in srgb, var(--secondaryColor), black 30%);\r\n}\r\n\r\n.btn-track-pdf-zip {\r\n  background-color: var(--green);\r\n  color: white;\r\n}\r\n.btn-track-pdf-zip:hover, .btn-track-pdf-zip:focus {\r\n  background-color: color-mix(in srgb, var(--green), black 17%);\r\n}\r\n.btn-track-pdf-zip:active {\r\n  background-color: color-mix(in srgb, var(--green), black 30%);\r\n}\r\n\r\n.btn-track-xml-zip {\r\n  background-color: #6472b6;\r\n  color: white;\r\n}\r\n.btn-track-xml-zip:hover, .btn-track-xml-zip:focus {\r\n  background-color: color-mix(in srgb, #6472b6, black 17%);\r\n}\r\n.btn-track-xml-zip:active {\r\n  background-color: color-mix(in srgb, #6472b6, black 30%);\r\n}\r\n\r\n.btn-track-xml {\r\n  background-color: var(--primaryColor);\r\n  color: white;\r\n}\r\n.btn-track-xml:hover, .btn-track-xml:focus {\r\n  background-color: color-mix(in srgb, var(--primaryColor), black 30%);\r\n}\r\n.btn-track-xml:active {\r\n  background-color: color-mix(in srgb, var(--primaryColor), black 50%);\r\n}\r\n\r\n.btn-track-pdf-outline {\r\n  background-color: transparent;\r\n  color: var(--secondaryColor);\r\n  border: 2px solid var(--secondaryColor);\r\n}\r\n.btn-track-pdf-outline:hover {\r\n  background-color: var(--secondaryColor);\r\n  color: white;\r\n}\r\n\r\n.btn-track-pdf-zip-outline {\r\n  background-color: transparent;\r\n  color: var(--green);\r\n  border: 2px solid var(--green);\r\n}\r\n.btn-track-pdf-zip-outline:hover {\r\n  background-color: var(--green);\r\n  color: white;\r\n}\r\n\r\n.btn-track-xml-outline {\r\n  background-color: transparent;\r\n  color: var(--primaryColor);\r\n  border: 2px solid var(--primaryColor);\r\n}\r\n.btn-track-xml-outline:hover {\r\n  background-color: var(--primaryColor);\r\n  color: white;\r\n}\r\n\r\n.track-header-buttons .btn-track:disabled {\r\n  opacity: 0.5;\r\n}\r\n\r\n.popup-map-div #mapDiv {\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n/* #endregion Trate */\r\n/* #region Dokumenty */\r\n.viewport:has(#fileManagerPublishingTasksContainer) {\r\n  position: relative;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  isolation: isolate;\r\n}\r\n.viewport:has(#fileManagerPublishingTasksContainer) #view-content-preview {\r\n  z-index: 1000;\r\n}\r\n.viewport:has(#fileManagerPublishingTasksContainer) #fileManagerPublishingTasksContainer {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.viewport:has(#fileManagerPublishingTasksContainer) #view-content-preview-h1 {\r\n  color: var(--secondaryColor);\r\n  font-weight: bold;\r\n  margin: 0;\r\n  align-self: center;\r\n}\r\n.viewport:has(#fileManagerPublishingTasksContainer) .view-content-overlay {\r\n  display: none;\r\n  flex-direction: column;\r\n  height: calc(100% - 40px);\r\n}\r\n.viewport:has(#fileManagerPublishingTasksContainer) .overlay-view {\r\n  position: absolute;\r\n  top: 40px;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 300px;\r\n  background: white;\r\n  z-index: 1000;\r\n  overflow: hidden;\r\n  display: none;\r\n  border-left: 1px solid #ccc;\r\n}\r\n\r\n#fileManagerPublishingTasksContainer {\r\n  border: none;\r\n}\r\n\r\n/* #endregion Dokumenty */\r\n/* #region Mapa */\r\n#mappartial {\r\n  width: 100%;\r\n  height: calc(100vh - 56px);\r\n}\r\n#mappartial #mapMapa {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n#mappartial #mapMapa .top-left-corner {\r\n  position: absolute;\r\n  top: 40px;\r\n  left: 0;\r\n  z-index: 5000;\r\n}\r\n#mappartial #mapMapa .top-left-corner #dateFilter,\r\n#mappartial #mapMapa .top-left-corner #oblastFilter,\r\n#mappartial #mapMapa .top-left-corner #tools {\r\n  display: flex;\r\n  margin-bottom: 0.5rem;\r\n  padding-left: 0.75rem;\r\n}\r\n#mappartial #mapMapa .top-left-corner .icon-bg {\r\n  background-color: white;\r\n  border-radius: 7px;\r\n  width: 33px;\r\n  height: 33px;\r\n  padding: 3px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n#mappartial #mapMapa .top-left-corner .icon-bg .icon {\r\n  width: 27px;\r\n  height: 27px;\r\n  cursor: pointer;\r\n}\r\n#mappartial #mapMapa .top-left-corner .map-pop-up {\r\n  padding: 0.75rem 1rem;\r\n  background-color: white;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n  border-radius: 6px;\r\n  width: fit-content;\r\n  margin-inline-start: 0.5rem;\r\n}\r\n#mappartial #mapMapa .top-left-corner #oblastFilter .map-pop-up {\r\n  width: 225px;\r\n  padding: 0.75rem;\r\n}\r\n#mappartial #mapMapa .top-left-corner #oblastFilter .map-pop-up .oblast-label {\r\n  display: block;\r\n  font-weight: 600;\r\n  margin-bottom: 0.25rem;\r\n}\r\n#mappartial #mapMapa .top-left-corner #oblastFilter .map-pop-up .dx-datagrid-search-panel {\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0.5rem 0;\r\n}\r\n#mappartial #mapMapa .top-left-corner #dateFilter .map-pop-up .casovy-filter-label {\r\n  display: block;\r\n  font-weight: 600;\r\n  margin-bottom: 0.25rem;\r\n}\r\n#mappartial #mapMapa .top-left-corner #tools .map-pop-up {\r\n  width: 170px;\r\n  text-align: center;\r\n  padding: 0.75rem;\r\n}\r\n#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button {\r\n  width: 50%;\r\n  padding: 0.25rem;\r\n}\r\n#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button .tools-icon {\r\n  width: 27px;\r\n  height: 27px;\r\n}\r\n#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button #mapTileLayerIcon {\r\n  fill: none;\r\n  stroke: black;\r\n}\r\n#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button:hover {\r\n  cursor: pointer;\r\n}\r\n#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button:hover .tools-icon {\r\n  fill: var(--secondaryColor);\r\n}\r\n#mappartial #mapMapa .top-left-corner #tools .map-pop-up .tool-button:hover #mapTileLayerIcon {\r\n  fill: none;\r\n  stroke: #ff8c00;\r\n}\r\n#mappartial #mapDiv {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* #endregion Mapa */\r\n/* #endregion Popis site */\r\n/* #region Kontrolni Cinnost */\r\n.tagbox-scrollable .dx-texteditor-input-container {\r\n  max-height: 100px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.zamestnanec-dropdown .dx-list-item {\r\n  font-size: 10px;\r\n  line-height: 14px;\r\n}\r\n\r\n.new-popup-content .dx-tabpanel .dx-multiview-item-content {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  max-height: 500px;\r\n}\r\n\r\n/* #endregion Kontrolni Cinnost */\r\n/* #region Kalendar */\r\n.calendar-event-detail {\r\n  padding: 2px 8px;\r\n}\r\n.calendar-event-detail:hover {\r\n  background-color: var(--primaryColor);\r\n  color: white;\r\n}\r\n\r\n.dx-popup-wrapper.dx-scheduler-appointment-tooltip-wrapper .dx-popup-content .dx-list-item .dx-list-item-content:has(.calendar-event-detail) {\r\n  padding: 0;\r\n}\r\n\r\n/* #endregion Kalendar */\r\n/* #region Smernice */\r\n#bodyContainer {\r\n  display: flex;\r\n  height: 100%;\r\n}\r\n#bodyContainer .menu {\r\n  width: 220px;\r\n  padding: 1rem 0;\r\n  border-right: 1px solid #ccc;\r\n  overflow: auto;\r\n}\r\n#bodyContainer .menu a {\r\n  display: block;\r\n  text-decoration: none;\r\n  color: var(--primaryColor);\r\n  font-size: 14px;\r\n  padding: 0.5rem 1.25rem;\r\n}\r\n#bodyContainer .menu a:hover {\r\n  background-color: var(--primaryColor);\r\n  color: white;\r\n}\r\n#bodyContainer .menu button {\r\n  padding: 0.5rem 0.75rem;\r\n  margin: 0.5rem 0.75rem;\r\n  border: none;\r\n  background-color: var(--primaryColor);\r\n  color: white;\r\n  font-size: 14px;\r\n  border-radius: 4px;\r\n  text-transform: uppercase;\r\n}\r\n#bodyContainer .menu button:hover {\r\n  background-color: var(--supplementaryColor);\r\n}\r\n#bodyContainer .content {\r\n  padding: 1rem 1.25rem;\r\n  overflow: auto;\r\n}\r\n\r\n/* #endregion Smernice */\r\n/* #endregion Kontrolni Cinnost*/\r\n/* #region Sprava obsahu */\r\n#fileManager {\r\n  height: 100%;\r\n}\r\n#fileManager .dx-filemanager .dx-filemanager-breadcrumbs {\r\n  border-bottom: none;\r\n}\r\n#fileManager .dx-filemanager-details.dx-filemanager-files-view {\r\n  padding-right: 0.5rem;\r\n}\r\n\r\n.new-popup-cell-input.popup-button {\r\n  padding: 10px 0;\r\n}\r\n\r\n.dx-popup-content:has(.popup-footer) {\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.popup-footer {\r\n  background-color: white;\r\n  position: absolute;\r\n  bottom: 0;\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: start;\r\n  padding: 0.75rem 2rem 1rem 0;\r\n}\r\n\r\n/* #endregion Sprava obsahu */\r\n/* #region Administrace */\r\n/* #region Správa skupin */\r\n#usersGrid .dx-toolbar-after {\r\n  width: 100% !important;\r\n  padding: 0 !important;\r\n}\r\n#usersGrid .dx-toolbar-after .dx-datagrid-search-panel {\r\n  width: 100% !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n/* #endregion Správa skupin */\r\n/* #region Administrace */\r\n/* Start Úprava TitleBaru */\r\n#titleBar {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n#titleBar > .titleBar-name {\r\n  flex: 0 1 auto;\r\n  width: auto;\r\n  justify-content: flex-start;\r\n  margin-right: auto;\r\n  padding-left: 0;\r\n}\r\n#titleBar #btnSearch,\r\n#titleBar #btnHelp {\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n}\r\n#titleBar #btnSearch:hover,\r\n#titleBar #btnHelp:hover {\r\n  color: var(--secondaryColor);\r\n}\r\n\r\n/* Konec Úprava TitleBaru */\r\n/* Start Ribbon horizontal menu */\r\n.main-ribbon-container {\r\n  border-bottom: solid 1px var(--secondaryColor);\r\n  /* Moduly */\r\n  /* Tasky / Submoduly */\r\n  /* Hlavní obsah pro funkce a filtry */\r\n  /* Společné */\r\n  /* Funkce / filtry */\r\n  /* Legacy funkce / filtry */\r\n}\r\n.main-ribbon-container .rh-menu {\r\n  padding-top: 0.25rem;\r\n  background: var(--primaryColor);\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n.main-ribbon-container .rh-menu .rh-menu-item {\r\n  color: #fff;\r\n  cursor: pointer;\r\n  padding: 4px 8px 4px 8px;\r\n  white-space: nowrap;\r\n  border-top: 1px solid transparent;\r\n  border-top-left-radius: 5px 5px;\r\n  border-top-right-radius: 5px 5px;\r\n}\r\n.main-ribbon-container .rh-menu .rh-menu-item:hover {\r\n  background: var(--secondaryColor);\r\n}\r\n.main-ribbon-container .rh-menu .rh-menu-item.selected {\r\n  background: var(--activeModulColor);\r\n  font-weight: bold;\r\n}\r\n.main-ribbon-container .rh-menu .rh-menu-item.active {\r\n  background: #bfc7da;\r\n  color: var(--primaryColor);\r\n}\r\n.main-ribbon-container .rh-submenu {\r\n  height: 36px;\r\n  color: var(--primaryColor);\r\n  background: #bfc7da;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: center;\r\n  overflow: hidden;\r\n  /* Scrollovací část panelu */\r\n  /* Tlačítko pro skrytí/zobrazení funkcí */\r\n}\r\n.main-ribbon-container .rh-submenu .rh-submenu-scroll {\r\n  height: 100%;\r\n  min-width: 0;\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  align-items: center;\r\n  margin-left: 2px;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n}\r\n.main-ribbon-container .rh-submenu .rh-submenu-scroll::-webkit-scrollbar {\r\n  height: 3px;\r\n}\r\n.main-ribbon-container .rh-submenu .rh-submenu-scroll::-webkit-scrollbar-track {\r\n  background-color: rgba(255, 255, 255, 0.04);\r\n}\r\n.main-ribbon-container .rh-submenu .rh-submenu-scroll::-webkit-scrollbar-thumb {\r\n  background-color: var(--primaryColor);\r\n}\r\n.main-ribbon-container .rh-submenu .rh-submenu-scroll .rh-submenu-item {\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  margin: 5px 2px;\r\n  white-space: nowrap;\r\n  background: rgb(223.3168316832, 227.2772277228, 236.6831683168);\r\n  border: 1px solid transparent;\r\n  border-radius: 3px;\r\n}\r\n.main-ribbon-container .rh-submenu .rh-submenu-scroll .rh-submenu-item:hover {\r\n  background: var(--secondaryColor);\r\n  color: #fff;\r\n}\r\n.main-ribbon-container .rh-submenu .rh-submenu-scroll .rh-submenu-item.selected {\r\n  background: var(--activeModulColor);\r\n  color: #fff;\r\n  font-weight: bold;\r\n}\r\n.main-ribbon-container .rh-submenu .rh-submenu-scroll .rh-submenu-item-separator {\r\n  width: 1px;\r\n  height: 20px;\r\n  margin: 0;\r\n  padding: 0;\r\n  border-right: solid 1px var(--companyGray);\r\n  flex: 0 0 1px;\r\n}\r\n.main-ribbon-container .rh-submenu .rh-toggle-button {\r\n  height: 100%;\r\n  width: 32px;\r\n  min-width: 32px;\r\n  flex: 0 0 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--primaryColor);\r\n  background: #bfc7da;\r\n  cursor: pointer;\r\n  z-index: 2;\r\n}\r\n.main-ribbon-container .main-ribbon-content {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  line-height: normal;\r\n}\r\n.main-ribbon-container .main-ribbon-content::-webkit-scrollbar {\r\n  height: 3px;\r\n}\r\n.main-ribbon-container .main-ribbon-content::-webkit-scrollbar-track {\r\n  background-color: rgba(255, 255, 255, 0.04);\r\n}\r\n.main-ribbon-container .main-ribbon-content::-webkit-scrollbar-thumb {\r\n  background-color: var(--secondaryColor);\r\n}\r\n.main-ribbon-container .rh-function,\r\n.main-ribbon-container .rh-function-legacy {\r\n  padding: 0 0.25rem 0 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  width: max-content;\r\n  flex: 0 0 auto;\r\n  list-style: none;\r\n}\r\n.main-ribbon-container .rh-function {\r\n  /* Oddělovač skupin */\r\n}\r\n.main-ribbon-container .rh-function .rh-function-group {\r\n  list-style: none;\r\n  padding: 0 2px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 80px;\r\n  flex: 0 0 auto;\r\n  /* SKupina položek */\r\n  /* Popis skupiny položek */\r\n}\r\n.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items {\r\n  height: 80px;\r\n  min-height: 80px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  align-items: center;\r\n  /* Jednotlivé položky */\r\n}\r\n.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items .rh-function-item {\r\n  width: min-content;\r\n  min-width: 50px;\r\n  max-width: 80px;\r\n  max-height: 76px;\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  font-size: 10.7px;\r\n  border: none;\r\n  background: none;\r\n}\r\n.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items .rh-function-item .icon {\r\n  height: 25px;\r\n  width: 25px;\r\n  margin: 0 auto;\r\n  flex: 0 0 25px;\r\n  /* Bootstrap Icons glyf (<i class=\"bi ...\">) použitý namísto <img> -\r\n     bez explicitního font-size zůstává v defaultní (malé) velikosti\r\n     textu, protože width/height na fontové ikoně nic nedělá. Zarovnání\r\n     uvnitř 25px boxu stejně jako u obrázkových ikon ribbonu. */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items .rh-function-item .icon .bi {\r\n  font-size: 25px;\r\n  line-height: 1;\r\n}\r\n.main-ribbon-container .rh-function .rh-function-group .rh-function-group-items .rh-function-item .text {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 3;\r\n  width: min-content;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  overflow-wrap: normal;\r\n  text-overflow: ellipsis;\r\n}\r\n.main-ribbon-container .rh-function .rh-function-group .rh-functions-caption {\r\n  height: 0px;\r\n  min-height: 0px;\r\n  text-align: center;\r\n  color: var(--companyGray);\r\n  border-top: 1px solid rgba(0, 0, 0, 0.0392156863);\r\n  padding: 2px 5px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-size: 0.8em;\r\n}\r\n.main-ribbon-container .rh-function .rh-function-group-separator {\r\n  list-style: none;\r\n  border-right: solid 1px var(--companyGray);\r\n  width: 1px;\r\n  min-width: 1px;\r\n  height: 80px;\r\n  flex: 0 0 1px;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroup {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer {\r\n  height: 80px;\r\n  min-height: 80px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0;\r\n  width: min-content;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer li {\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n  list-style: none;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer .mainRibbonBtn {\r\n  font-size: 10.7px;\r\n  border: none;\r\n  background: none;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer .mainRibbonBtn .mainRibbonBtnImg {\r\n  height: 25px;\r\n  width: 25px;\r\n  margin: 0 auto;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer .mainRibbonBtn .mainRibbonBtnCaption {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 3;\r\n  width: 100%;\r\n  padding: 3px 2px 0;\r\n  overflow: hidden;\r\n  overflow-wrap: break-word;\r\n  text-overflow: ellipsis;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubGroupContainer .btn-track {\r\n  padding: 3px 13px;\r\n  border: 2px solid transparent;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroup .mainRibbonSubModule {\r\n  text-align: center;\r\n  color: var(--companyGray);\r\n  border-top: 1px solid rgba(0, 0, 0, 0.0392156863);\r\n  padding: 2px 5px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  font-size: 0.8em;\r\n}\r\n.main-ribbon-container .rh-function-legacy .mainRibbonGroupSep {\r\n  list-style: none;\r\n  border-right: solid 1px var(--companyGray);\r\n  width: 1px;\r\n}\r\n\r\n/* End Ribbon horizontal menu */\r\n/* #region Podrobné vyhledávání */\r\n#searchPage #reactSearchInputRoot {\r\n  max-width: 500px;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n#searchPage #reactDataGridRoot {\r\n  width: 100% !important;\r\n}\r\n\r\n/* #endregion Podrobné vyhledávání */\r\n/* #region Sprava obsahu - inline editor článku (mimo dxPopup) */\r\n#articleEditorInline {\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n/*\r\n    Layout bez tabů - přepínání pohledu (HTML editor/Textový editor/Náhled) řeší\r\n    tlačítka v ribbonu (viz `_ArticleEditorRibbon.cshtml` a\r\n    `CurrentTask.setArticleEditorMode`). Panel metadat vpravo lze skrýt/zobrazit\r\n    úzkým tlačítkem přilepeným na jeho levé hraně (stejný přístup jako sbalování\r\n    stromu složek ve FileManageru - viz `FileManager.tsx`/`file-manager-aside-toggle`)\r\n    a horizontálně měnit jeho šířku tažením za \"resize handle\" vlevo od panelu\r\n    (`ContentManagerTask.handleArticleMetadataResizeStart`). Sbalený/rozbalený stav\r\n    a šířka se řeší čistě v JS (`ContentManagerTask.updateArticleMetadataPaneLayout`),\r\n    tyto styly jen definují vzhled jednotlivých elementů.\r\n*/\r\n.article-editor-inline-layout {\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n.article-editor-main {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* Vizuální okraj hlavního obsahu editoru je \"nalepený\" přímo na resize handle\r\n     panelu metadat (žádná mezera mezi nimi) - proto border, ne margin. */\r\n  border-right: 1px solid #eee;\r\n}\r\n\r\n.article-editor-pane {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  display: flex;\r\n}\r\n\r\n.article-editor-pane .jodit-container {\r\n  width: 100%;\r\n  height: 100% !important;\r\n}\r\n\r\n/* Panel metadat je trvale viditelný v pravé části hlavního okna - lze jej skrýt\r\n   úzkým tlačítkem `#articleMetadataAsideToggle` a horizontálně měnit tažením za\r\n   `#articleMetadataResizeHandle` - stejný přístup jako sbalování/resize stromu\r\n   složek ve FileManageru (`file-manager-aside-toggle`/`file-manager-tree-resize-handle`,\r\n   viz FileManager.css). Sbalení i šířka (`style.width`) se nastavují přímo v JS\r\n   (`ContentManagerTask.updateArticleMetadataPaneLayout`), třída zde jen definuje\r\n   výchozí vzhled panelu. */\r\n.article-metadata-pane {\r\n  flex: 0 0 auto;\r\n  width: 380px;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: 0.5rem 0.75rem;\r\n  border-left: 1px solid #eee;\r\n  /* Panel je úzký - řádky/buňky navržené pro široký popup\r\n     (`new-popup-row`/`new-popup-cell` vedle sebe) se v tomto panelu řadí\r\n     pod sebe, aby se prvky nemačkaly do jednoho úzkého sloupce. */\r\n}\r\n.article-metadata-pane .new-popup-row {\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 0 0 15px;\r\n}\r\n.article-metadata-pane .new-popup-cell {\r\n  width: 100% !important;\r\n}\r\n.article-metadata-pane .new-popup-cell .dx-widget {\r\n  width: 100% !important;\r\n}\r\n.article-metadata-pane .new-popup-cell:has(div.dx-button) {\r\n  align-self: stretch;\r\n}\r\n.article-metadata-pane .new-popup-cell.mt-auto {\r\n  margin-top: 0 !important;\r\n}\r\n\r\n/* Resize handle panelu metadat - stejný vzhled/chování jako\r\n   `.file-manager-tree-resize-handle` ve FileManageru (viz FileManager.css). */\r\n.article-metadata-resize-handle {\r\n  width: 5px;\r\n  flex-shrink: 0;\r\n  cursor: col-resize;\r\n  background-color: transparent;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.article-metadata-resize-handle:hover {\r\n  background-color: #c0d0e0;\r\n}\r\n\r\n/* Úzké sbalovací tlačítko panelu metadat - stejný vzhled jako\r\n   `.file-manager-aside-toggle` ve FileManageru, jen zrcadlově (panel je vpravo,\r\n   ne vlevo). Nalepené na obě strany bez mezery - vlevo na resize handle (tvoří\r\n   s ním vizuálně souvislý pruh), vpravo přímo na okraj panelu metadat. */\r\n.article-metadata-aside-toggle {\r\n  align-self: flex-start;\r\n  width: 14px;\r\n  height: 28px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  color: #002B59;\r\n  background-color: #f0f4fa;\r\n  border: 1px solid #d0d0d0;\r\n  border-right: none;\r\n  cursor: pointer;\r\n  margin-top: 8px;\r\n  z-index: 1;\r\n}\r\n\r\n.article-metadata-aside-toggle:hover {\r\n  background-color: #e7f1ff;\r\n}\r\n\r\n/* Náhled článku - přepíná se tlačítky v ribbonu (viz setArticleEditorMode) -\r\n   vykreslí se přímo do hlavního okna editoru namísto popupu/nového okna. */\r\n.article-preview-pane {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n/* #endregion */\r\n/* #region Sdílený WYSIWYG HTML editor v ribbonu (viz Scripts/Shared/HtmlRichTextEditor) -\r\n   obecný styl, použitelný pro libovolné použití editoru v aplikaci, nejen Content Manager */\r\n/* Kontejner toolbaru editoru vykresleného do ribbonu - viz\r\n   HtmlRichTextEditorRibbonRenderer.render(). V \"native\" režimu (Jodit) sem knihovna\r\n   vykreslí svůj vlastní toolbar (toolbar: HTMLElement), zde se jen potlačí jeho\r\n   vlastní rámeček/pozadí, aby zapadl do vzhledu ribbonu. */\r\n.html-rich-text-editor-ribbon-toolbar {\r\n  width: 100%;\r\n}\r\n\r\n.html-rich-text-editor-ribbon-toolbar .jodit-toolbar-editor-collection {\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 0;\r\n}\r\n\r\n.html-rich-text-editor-ribbon-toolbar .jodit-toolbar__box {\r\n  background-color: transparent;\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n/* Styl tlačítek pro \"commands\" fallback režim (viz HtmlRichTextEditorRibbonRenderer) -\r\n   používá se jen pro implementace editoru bez podpory nativního toolbaru v cizím\r\n   kontejneru; pro Jodit (native режим) se tyto třídy nevyužívají. */\r\n.rh-function-editor-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.rh-function-editor-separator {\r\n  width: 1px;\r\n  height: 24px;\r\n  background-color: #ccc;\r\n  margin: 0 4px;\r\n}\r\n\r\n/* Velikost ikony/textu sjednocená s klasickým ribbonem (viz .rh-function-item .icon\r\n   výše v souboru) - editor toolbar má vypadat vizuálně stejně dominantně jako běžné\r\n   ribbon položky, ne jako drobné pomocné ikony. */\r\n.rh-function-editor-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 4px 6px;\r\n  cursor: pointer;\r\n  font-size: 10.7px;\r\n  min-width: 50px;\r\n}\r\n.rh-function-editor-item .icon {\r\n  height: 25px;\r\n  width: 25px;\r\n  margin: 0 auto;\r\n  flex: 0 0 25px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.rh-function-editor-item .icon .bi {\r\n  font-size: 25px;\r\n  line-height: 1;\r\n}\r\n.rh-function-editor-item .text {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 3;\r\n  width: min-content;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  overflow-wrap: normal;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.rh-function-editor-item:hover {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n.rh-function-editor-item-active {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n.rh-function-editor-item:disabled {\r\n  opacity: 0.4;\r\n  cursor: default;\r\n}\r\n\r\n.rh-function-editor-trigger {\r\n  position: absolute;\r\n  right: 3px;\r\n  bottom: 4px;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 4px solid transparent;\r\n  border-right: 4px solid transparent;\r\n  border-top: 5px solid currentColor;\r\n  opacity: 0.6;\r\n}\r\n\r\n/* Split tlačítko (kind:\"split\" - odrážky/číslování): hlavní ikona provede přímou akci\r\n   (toggle), samostatná šipka vedle ní rozbalí nabídku stylů (viz\r\n   HtmlRichTextEditorToolbarRenderer.createSplitCommandButton a\r\n   JoditToolbarCommandFactory - control.list u ul/ol). */\r\n.rh-function-editor-split {\r\n  display: flex;\r\n  align-items: stretch;\r\n  border: none;\r\n}\r\n\r\n.rh-function-editor-split .rh-function-editor-split-main {\r\n  border: none;\r\n  background: transparent;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 4px 4px 4px 6px;\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n}\r\n\r\n.rh-function-editor-split .rh-function-editor-split-main:hover {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n.rh-function-editor-split .rh-function-editor-split-main.rh-function-editor-item-active {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n.rh-function-editor-split-arrow {\r\n  border: none;\r\n  background: transparent;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 14px;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  color: inherit;\r\n}\r\n\r\n.rh-function-editor-split-arrow:hover {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n.rh-function-editor-split-arrow .rh-function-editor-trigger {\r\n  position: static;\r\n  border-top-color: currentColor;\r\n  opacity: 0.7;\r\n}\r\n\r\n/* Vlastní popup ukotvený k tlačítku ribbonu editoru (viz AnchoredPopup.ts) - obaluje se\r\n   do Joditových tříd .jodit-popup/.jodit-popup__content (viz jodit.min.css, importováno\r\n   přes JoditHtmlRichTextEditor.ts), takže dodatečné pozadí/stín/padding zajišťuje sám\r\n   Jodit; zde jen doladíme rozestupy a scroll dlouhých seznamů. */\r\n.html-rich-text-editor-popup .html-rich-text-editor-popup-content {\r\n  max-height: 320px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.html-rich-text-editor-popup-list {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.html-rich-text-editor-popup-item {\r\n  width: 100%;\r\n  text-align: left;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n}\r\n.html-rich-text-editor-popup-item .jodit-toolbar-button__text {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n/* Ribbon během editace/vytváření článku - server-rendered partial\r\n   `_ArticleEditorRibbon.cshtml`, který dodržuje stejnou strukturu jako standardní\r\n   funkční ribbon Content Manageru (.rh-function > .rh-function-group >\r\n   .rh-function-group-items > .rh-function-item), takže výška\r\n   ($ribbon-function-total-height) a vzhled zůstávají shodné s \"normálním\"\r\n   zobrazením ribbonu - mění se jen jeho obsah (Uložit/Zrušit, přepínání pohledu\r\n   a toolbar editoru; skrývání/resize metadat je od tlačítek v ribbonu přesunuté\r\n   přímo k panelu metadat, viz `.article-metadata-aside-toggle`/\r\n   `.article-metadata-resize-handle` výše). */\r\n.article-editor-ribbon-toolbar-group {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.article-editor-ribbon-toolbar-wrapper {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/* #region AdminUserRole */\r\n.admin-user-role-action-column {\r\n  width: 220px;\r\n}\r\n\r\n.admin-user-role-roles-column {\r\n  min-height: 519.5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.admin-user-role-default-role {\r\n  margin-top: auto;\r\n}\r\n\r\n/* #endregion AdminUserRole */\r\n/* #region PublishingTasks - ribbonové vyhledávání */\r\n.publishingTasksSearchGroup .mainRibbonSubGroupContainer {\r\n  height: 80px;\r\n  min-height: 80px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 0;\r\n  width: max-content;\r\n}\r\n.publishingTasksSearchGroup .mainRibbonSubGroup {\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n  list-style: none;\r\n}\r\n.publishingTasksSearchGroup .publishingTasksSearchContainer {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer {\r\n  width: auto;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input {\r\n  width: auto;\r\n  max-width: none;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input form {\r\n  display: flex;\r\n  align-items: center;\r\n  width: auto;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer .input-group {\r\n  width: 280px;\r\n  padding-inline: 0;\r\n  display: flex;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input-filters {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  margin-top: 0;\r\n  margin-left: 8px;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer .form-check {\r\n  margin: 0;\r\n  white-space: nowrap;\r\n  font-size: small;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer .form-check-input {\r\n  margin-top: 0;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input-field .form-control {\r\n  height: 26px;\r\n  font-size: 13px;\r\n}\r\n.publishingTasksSearchGroup #searchInputPublishingTasksContainer .search-input-submit .btn {\r\n  height: 26px;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.publishingTasksSearchGroup .mainRibbonSubModule {\r\n  text-align: center;\r\n  color: var(--companyGray);\r\n  border-top: 1px solid rgba(0, 0, 0, 0.0392156863);\r\n  padding: 2px 5px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  font-size: 0.8em;\r\n}\r\n\r\n/* #region PublishingTasks */\r\n#searchInputComponent .form-check {\r\n  font-size: large;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
